if (typeof wlcApiUrl == 'undefined') {
  Date.prototype.addMinutes = function(minutes) {
    var copiedDate = new Date(this.getTime());
    return new Date(copiedDate.getTime() + minutes * 60000 - 10000);
  }
  window.getLocalDetails = () => {
    let defaultContent;
    if (localStorage.getItem("th_default_settings_content")) {
      defaultContent = localStorage.getItem("th_default_settings_content");
    }
    var valueInJSON2;
    if (typeof defaultContent == 'string') {
      valueInJSON2 = JSON.parse(defaultContent);
    }
    return valueInJSON2;
  }
  const getLocalRecords = () => {
    let defaultContent;
    if (localStorage.getItem("th_wishlist_products_list")) {                                                                                                                                                                                                                                               
      defaultContent = localStorage.getItem("th_wishlist_products_list");
    }
    var valueInJSON2;
    if (typeof defaultContent == 'string') {
      valueInJSON2 = JSON.parse(defaultContent);
    }
    return valueInJSON2;
  }
  const getLocalthWishlists = () => {
    let defaultContent;
    if (localStorage.getItem("th_wishlist_lists")) {
      defaultContent = localStorage.getItem("th_wishlist_lists");
    }
    var valueInJSON2;
    if (typeof defaultContent == 'string') {
      valueInJSON2 = JSON.parse(defaultContent);
    }
    return valueInJSON2;
  }
  const getCookieFromName = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  const setCookieFromName = (cname, cvalue) => {
    const d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  window.totalCountUpdate = () => {
    var updateCount = parseInt(localStorage.getItem('th_wlc_pro_count')) || 0;
    if (updateCount > 0) {
      document.querySelectorAll('.th_wlc_position_relative').forEach(function(self){
        if (self.querySelector('.th_wlc_product_count')) {
          self.querySelector('.th_wlc_product_count').style.display = 'flex';
          self.querySelector('.th_wlc_product_count').innerHTML = updateCount;
        }
      });
    } else {
      document.querySelectorAll('.th_wlc_position_relative').forEach(function(self){
        if (self.querySelector('.th_wlc_product_count')) {
          self.querySelector('.th_wlc_product_count').style.display = 'none';
        }
      });
    }
  }
  let wlcShop = Shopify.shop;
  // let wlcApiUrl = "https://rivyo.com/wishlist/api/public/api";
  window.wlcApiUrl = "https://wishlist.thimatic-apps.com/api/public/api";
  let wlcPage = document.querySelector('.wc_pagetype').getAttribute('data-page') ? document.querySelector('.wc_pagetype').getAttribute('data-page') : 'home';
  var wlcCustomer_id = document.querySelector('.wc_customer_id') ? parseInt(document.querySelector('.wc_customer_id').getAttribute('data-customer-id')) : ShopifyAnalytics?.meta?.page?.customerId;
  if (isNaN(wlcCustomer_id)) {wlcCustomer_id = null}

  window.wl_update_customer_id=()=>{
     wlcCustomer_id = document.querySelector('.wc_customer_id') ? parseInt(document.querySelector('.wc_customer_id').getAttribute('data-customer-id')) : ShopifyAnalytics?.meta?.page?.customerId;
    if (isNaN(wlcCustomer_id)) {wlcCustomer_id = null}
  }
  let valueInJSON = getLocalDetails();
  let record = getLocalRecords();
  let iconBefor;
  let iconAfter;
  let deleteIcon;
  let cookieSettingVersion = getCookieFromName('settingVersion') || 0;
  let settingVersion = parseInt(document.querySelector('.th_setting_version_for_wishlist') ? document.querySelector('.th_setting_version_for_wishlist')?.getAttribute('data-setting-version') : "-1");
  let th_wishlist = getLocalthWishlists() || [];
  let totalCount = parseInt(localStorage.getItem('th_wlc_pro_count')) || 0;
  const getSettingsDetailsFrom = async () => {
    wl_update_customer_id();
    let wc_ip = getCookieFromName('wlcIp') ? getCookieFromName('wlcIp') : '';
    let data_json = JSON.stringify({ shop: wlcShop, customer_id: wlcCustomer_id, ip: wc_ip });
    const response = await fetch(wlcApiUrl + '/v2/setting', {
      method: 'POST',
      body: data_json,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const myJson = await response.json();
    if (myJson.status == 200 && myJson.data.setting.app_enable === 1) {
      var myJSON2 = JSON.stringify(myJson);
      localStorage.setItem("th_default_settings_content", myJSON2);
      valueInJSON = getLocalDetails();
      localStorage.setItem('th_wishlist_lists', JSON.stringify(valueInJSON.data.wishlist));
      th_wishlist = getLocalthWishlists();
      if (!wc_ip) {
        setCookieFromName('wlcIp', valueInJSON.data.ip);
      }
      addCSSToProducts();
      getListofWishlistBlocks();
      setCookieFromName('is_variant_wishlist', valueInJSON.data.setting.is_variant_wishlist);
      wantToGetProductWishlistedItems();
    }
  }
  const th_change_details_in_current_records = (singleProductDetailsToBeChanged) => {
    var prd_id = singleProductDetailsToBeChanged[0]['shopify_product_id'];
    var record2 = [];
    const filteredRecord = record.filter(product => product.shopify_product_id !== prd_id);
    record = filteredRecord;
    for (let itemCount2 = 0; itemCount2 < singleProductDetailsToBeChanged.length; itemCount2++) {
      var copiedDate = Number(new Date())
      singleProductDetailsToBeChanged[itemCount2].timestamp = copiedDate;
      record.push(singleProductDetailsToBeChanged[itemCount2]);
    }
  }
  const th_get_prod_details_from_apis = async (prd_ids) => {
    wl_update_customer_id();
    let data_json = JSON.stringify({ shop: wlcShop, product_ids: prd_ids, ip: valueInJSON.data.ip, customer_id: wlcCustomer_id });
    const response = await fetch(wlcApiUrl + '/v3/wishlists', {
        method: 'POST',
        body: data_json,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const myJson = await response.json();
    if (myJson.status === 200) {
      var productListing = myJson.data.products;
      let goneProducts = [];
      var productListingJSON = JSON.stringify(productListing);
      for (var starting = 0; starting < productListing.length; starting++) {
        if (!goneProducts.includes(productListing[starting]['shopify_product_id'])) {
            let sharingList = productListing.filter((wl_response_pro)=>wl_response_pro.shopify_product_id==productListing[starting].shopify_product_id);
            th_change_details_in_current_records(sharingList);
            goneProducts.push(productListing[starting]['shopify_product_id']);
        }
        localStorage.setItem("th_wishlist_products_list", JSON.stringify(record));
      }
      localStorage.setItem('th_wlc_pro_count', myJson.data.total);
      totalCountUpdate();
      getListofWishlistBlocks();
    }
  }
  const getProductsWithStaleTimestamps = (record) => {
    const currentTime = Date.now();
    const prd_ids = [];
    for (var starting = 0; starting < record.length; starting++) {
      const timestampGap = currentTime - record[starting].timestamp;
      const isMoreThanAMinute = parseInt(timestampGap) > 2 * 60 * 1000;
      if (isMoreThanAMinute) {
        prd_ids.push(record[starting].shopify_product_id);
      }
    }
   return prd_ids; 
  }
  const wantToGetProductWishlistedItems = () => {
    const currentTime = Date.now();
    var prd_ids = [];
    document.querySelectorAll('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').forEach( (self) => {
      var singleId = self.getAttribute('data-product_id');
      prd_ids.push(singleId);
    });
    const unique_ids = Array.from(new Set(prd_ids));
    var uniqueIDSString = JSON.stringify(unique_ids);
    const filteredRecord = record.filter(product => uniqueIDSString.includes(product.shopify_product_id) == true && parseInt(currentTime - product.timestamp) > 2 * 60 * 1000);
    const ids = Array.from(new Set(filteredRecord.map(product => product.shopify_product_id)));
    if (ids.length > 0) {
      th_get_prod_details_from_apis(ids);
    }
  }
  const getparticularWishlistBlocks = (prd_id) => {
    var productList = [];
    let button_text_before = "Add to Wishlist";
    let button_type = "1";
    let total_count = "0";
    let className = 'th_wl_button';
    let buttonCol_color_before2 = "#000000";
    let multiple_wishlist = 0;
    let externalContent = '';
    if (th_wishlist) {
      th_wishlist.forEach((x) => {
        externalContent += '<li><span class="th_wl_dropdown_option" data-wishlistid="' + x.id + '" onclick="addItemWithWishlisted(this,event)" data-wishlist_dropdown_text="' + valueInJSON.data.setting.wishlist_dropdown_text + '">' + x.name + '</span><span class="th_wl_dropdown_option_delete_btn" data-wishlistid="' + x.id + '"  data-wishlist_dropdown_text="' + valueInJSON.data.setting.wishlist_dropdown_text + '" onclick="onDeleteWishListList(this)">' + deleteIcon + '</span></li>';
      });
    }
    if (record) {
      var listofprdIDS = [];
      document.querySelectorAll('.th_wl_col_btn[data-product_id="'+ prd_id +'"], .th_prd_wl_btn[data-product_id="'+ prd_id +'"], .th_wl_btn[data-product_id="'+ prd_id +'"]').forEach( (self) => {
        var data_prd_id = parseInt(self.getAttribute('data-product_id'));
        var data_var_id = parseInt(self.getAttribute('data-variant_id'));
        var stringlistofprdIDS = JSON.stringify(listofprdIDS);
        if (!stringlistofprdIDS.includes(data_prd_id)) {
          listofprdIDS.push(data_prd_id);
        }
        var wishlistCount = 0;
        var wishlisted = false;
        var timestamp = Number(new Date().addMinutes(-5));

        var productAlreadyNotThere = true;
        if (valueInJSON.data.setting.is_variant_wishlist == 1) {
          var singleProduct = { shopify_product_id: data_prd_id, shopify_variant_id: data_var_id, wishlistCount: wishlistCount, wishlisted: false, timestamp: timestamp ,folder:[]}
        } else {
          var singleProduct = { shopify_product_id: data_prd_id, wishlistCount: wishlistCount, wishlisted: false, timestamp: timestamp ,folder:[]}
        }
        let stringRecord = JSON.stringify(record);
        if (stringRecord.includes(data_prd_id)) {
          productAlreadyNotThere = false;
        }
        if (productAlreadyNotThere) {
          record.push(singleProduct);
        }
      });
      var stringlistofprdIDS = JSON.stringify(listofprdIDS);
      const filteredRecord2 = record.filter(product => stringlistofprdIDS.includes(product.shopify_product_id) == true);
      document.querySelectorAll('.th_wl_col_btn[data-product_id="'+ prd_id +'"], .th_prd_wl_btn[data-product_id="'+ prd_id +'"], .th_wl_btn[data-product_id="'+ prd_id +'"]').forEach( (self) => {
        commanCodeForWlColBtn(self, button_text_before, button_type, total_count, className, buttonCol_color_before2, multiple_wishlist, externalContent, filteredRecord2);
      });
      let prodLIST = JSON.stringify(record);
      localStorage.setItem("th_wishlist_products_list", prodLIST);
    } else {
      document.querySelectorAll('.th_wl_col_btn[data-product_id="'+ prd_id +'"], .th_prd_wl_btn[data-product_id="'+ prd_id +'"], .th_wl_btn[data-product_id="'+ prd_id +'"]').forEach( (self) => {
        var data_prd_id = parseInt(self.getAttribute('data-product_id'));
        var data_var_id = parseInt(self.getAttribute('data-variant_id'));
        var wishlistCount = 0;
        var wishlisted = false;
        var timestamp = Number(new Date().addMinutes(-5));
        if (valueInJSON.data.setting.is_variant_wishlist == 1) {
          var singleProduct = { shopify_product_id: data_prd_id, shopify_variant_id: data_var_id, wishlistCount: wishlistCount, wishlisted: false, timestamp: timestamp ,folder:[]}
        } else {
          var singleProduct = { shopify_product_id: data_prd_id, wishlistCount: wishlistCount, wishlisted: false, timestamp: timestamp ,folder:[]}
        }
        var productAlreadyNotThere= true;
        let stringRecord = JSON.stringify(productList);
        if (stringRecord.includes(data_prd_id)) {
          productAlreadyNotThere = false;
        }
        if (productAlreadyNotThere) {
          productList.push(singleProduct);
        }
        commanCodeForWlColBtn(self, button_text_before, button_type, total_count, className, buttonCol_color_before2, multiple_wishlist, externalContent, productList);
      });
      record = productList;
      let prodLIST = JSON.stringify(productList);
      localStorage.setItem("th_wishlist_products_list", prodLIST);
    }
  }
  const getListofWishlistBlocks = () => {
    var productList = [];
    let button_text_before = "Add to Wishlist";
    let button_type = "1";
    let total_count = "0";
    let className = 'th_wl_button';
    let buttonCol_color_before2 = "#000000";
    let multiple_wishlist = 0;
    let externalContent = '';
    if (th_wishlist) {
      th_wishlist.forEach((x) => {
        externalContent += '<li><span class="th_wl_dropdown_option" data-wishlistid="' + x.id + '" onclick="addItemWithWishlisted(this,event)" data-wishlist_dropdown_text="' + valueInJSON.data.setting.wishlist_dropdown_text + '">' + x.name + '</span><span class="th_wl_dropdown_option_delete_btn" data-wishlistid="' + x.id + '"  data-wishlist_dropdown_text="' + valueInJSON.data.setting.wishlist_dropdown_text + '" onclick="onDeleteWishListList(this)">' + deleteIcon + '</span></li>';
      });
    }
    record = getLocalRecords();
    if (record) {
      var listofprdIDS = [];
      document.querySelectorAll('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').forEach( (self) => {
        var data_prd_id = parseInt(self.getAttribute('data-product_id'));
        var data_var_id = parseInt(self.getAttribute('data-variant_id'));
        var stringlistofprdIDS = JSON.stringify(listofprdIDS);
        if (!stringlistofprdIDS.includes(data_prd_id)) {
          listofprdIDS.push(data_prd_id);
        }
        var wishlistCount = 0;
        var wishlisted = false;
        var timestamp = Number(new Date().addMinutes(-5));

        var productAlreadyNotThere = true;
        if (valueInJSON.data.setting.is_variant_wishlist == 1) {
          var singleProduct = { shopify_product_id: data_prd_id, shopify_variant_id: data_var_id, wishlistCount: wishlistCount, wishlisted: false, timestamp: timestamp ,folder:[]}
        } else {
          var singleProduct = { shopify_product_id: data_prd_id, wishlistCount: wishlistCount, wishlisted: false, timestamp: timestamp ,folder:[]}
        }
        let stringRecord = JSON.stringify(record);
        if (stringRecord.includes(data_prd_id)) {
          productAlreadyNotThere = false;
        }
        if (productAlreadyNotThere) {
          record.push(singleProduct);
        }
      });
      var stringlistofprdIDS = JSON.stringify(listofprdIDS);
      const filteredRecord2 = record.filter(product => stringlistofprdIDS.includes(product.shopify_product_id) == true);
      document.querySelectorAll('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').forEach( (self) => {
        commanCodeForWlColBtn(self, button_text_before, button_type, total_count, className, buttonCol_color_before2, multiple_wishlist, externalContent, filteredRecord2);
      });
      let prodLIST = JSON.stringify(record);
      localStorage.setItem("th_wishlist_products_list", prodLIST);
    } else {
      document.querySelectorAll('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').forEach( (self) => {
        var data_prd_id = parseInt(self.getAttribute('data-product_id'));
        var data_var_id = parseInt(self.getAttribute('data-variant_id'));
        var wishlistCount = 0;
        var wishlisted = false;
        var timestamp = Number(new Date().addMinutes(-5));
        if (valueInJSON.data.setting.is_variant_wishlist == 1) {
          var singleProduct = { shopify_product_id: data_prd_id, shopify_variant_id: data_var_id, wishlistCount: wishlistCount, wishlisted: false, timestamp: timestamp ,folder:[]}
        } else {
          var singleProduct = { shopify_product_id: data_prd_id, wishlistCount: wishlistCount, wishlisted: false, timestamp: timestamp ,folder:[]}
        }
        var productAlreadyNotThere= true;
        let stringRecord = JSON.stringify(productList);
        if (stringRecord.includes(data_prd_id)) {
          productAlreadyNotThere = false;
        }
        if (productAlreadyNotThere) {
          productList.push(singleProduct);
        }
        commanCodeForWlColBtn(self, button_text_before, button_type, total_count, className, buttonCol_color_before2, multiple_wishlist, externalContent, productList);
      });
      record = productList;
      let prodLIST = JSON.stringify(productList);
      localStorage.setItem("th_wishlist_products_list", prodLIST);
    }
  }
  const getTheProductDetails = (particularItem, filteredItems) => {
    var particularString = JSON.stringify(particularItem);
    if (particularString.includes('pId')) {
      var firstValue = parseInt(particularString.replace('{', '').replace('}', '').replaceAll('"', '').split(':')[1]);
      for (var index in filteredItems) {
        var shopifyProductId = parseInt(filteredItems[index]['shopify_product_id']);
        if (firstValue == shopifyProductId) {
          return filteredItems[index];
        }
      }
    }
    else {
      var firstValue = parseInt(particularString.replace('{', '').replace('}', '').split(':')[0].replace('"', ''));
      var secondValue = parseInt(particularString.replace('{', '').replace('}', '').split(':')[1].replace('"', ''));
      var isproVariantMatch = false;
      var recordmatch = {};
      var indexNumber;
      for (var index in filteredItems) {
        var shopifyProductId = parseInt(filteredItems[index]['shopify_product_id']);
        var shopifyVariantId = parseInt(filteredItems[index]['shopify_variant_id']);
        if (secondValue == shopifyProductId) {
          indexNumber = index;
          if (firstValue == shopifyVariantId) {
            isproVariantMatch = true;
            recordmatch = filteredItems[index];
          }
        }
      }
      if(isproVariantMatch == true) {
        return recordmatch;
      } else {
        let singleRecord = Object.assign({}, filteredItems[indexNumber]);
        singleRecord.wishlisted = false;
        singleRecord.shopify_variant_id = firstValue;
        singleRecord.folder=[];
        if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
           record.push(singleRecord);
           let prodLIST = JSON.stringify(record);
           localStorage.setItem("th_wishlist_products_list", prodLIST);
        }
        return singleRecord;
      }
    }
  }
   window.th_wl_add_and_remove_event_for_same_product_multiple_list_setting=(self)=>{
     let th_wl_wishlist_status=self.dataset.th_wl_wishlist_status;
     let th_wishlist_id=parseFloat(self.getAttribute('data-wishlistid'));
     let prd_id = parseInt(self.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-product_id'));
     let var_id = parseInt(self.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-variant_id'));
       if(th_wl_wishlist_status=='true'){
         th_removefromwishlist_api(prd_id,var_id,th_wishlist_id);
       }else{
         th_addtowishlist_using_api(prd_id, var_id, th_wishlist_id);
       }
  }
  let th_wl_return_externalContent=(externalContent,prd_details)=>{
    if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
      let dropdown_wishlist_list_containor=document.createElement('div');
      dropdown_wishlist_list_containor.innerHTML=externalContent;

      let wishlist_lists=dropdown_wishlist_list_containor.querySelectorAll('.th_wl_dropdown_option');
      wishlist_lists.forEach((list_wishlist)=>{
        let tab_wishlist_id=list_wishlist.dataset.wishlistid;
        let th_wl_wishlist_status=false;
        if(prd_details.folder && prd_details.folder.length>0){
          prd_details.folder.forEach((wishlist_id)=>(tab_wishlist_id==wishlist_id)?th_wl_wishlist_status=true:'');
        }
        list_wishlist.outerHTML=`<span class='th_wl_wishlist_list_from_dropdown' data-th_wl_wishlist_status='${th_wl_wishlist_status}' onclick="th_wl_add_and_remove_event_for_same_product_multiple_list_setting(this)" data-wishlistid="${tab_wishlist_id}"><input type="checkbox" ${(th_wl_wishlist_status)?'checked':''}><span class='th_wl_dropdown_option' 
                                 data-wishlist_dropdown_text="${list_wishlist.dataset.wishlist_dropdown_text}">${list_wishlist.innerText}</span></span>`
        
      })
      return dropdown_wishlist_list_containor.innerHTML;
    }else{
     return externalContent; 
    }
  }
  
  const commanCodeForWlColBtn = (val, button_text_before, button_type, total_count, className, buttonCol_color_before2, multiple_wishlist, externalContent, filteredItems) => {
    val.innerHTML = '';
    var collection_page;
    let pId = val.getAttribute('data-product_id');
    let vId = val.getAttribute('data-variant_id');
    var prd_details = '';
    if (record) {
      if (valueInJSON.data.setting.is_variant_wishlist == 1) {
        if (vId) {
          var needDetails = { [vId] : pId };
          prd_details = getTheProductDetails(needDetails, filteredItems);
        }
      } else {
        if (pId) {
          var needDetails = {pId};
          prd_details = getTheProductDetails(needDetails, filteredItems);
        }
      }
    }
    if (val.classList.contains('th_wl_col_btn')) { collection_page = true; }
    else if (val.classList.contains('th_prd_wl_btn')) { collection_page = false; }
    else if (wlcPage === "product") { collection_page = false; }
    else { collection_page = true; }
    if (prd_details) {
      button_text_before = prd_details["wishlisted"]
        ? collection_page
          ? valueInJSON.data.setting.product_collection_button_text_after
          : valueInJSON.data.setting.button_text_after
        : collection_page
        ? valueInJSON.data.setting.product_collection_button_text_before
        : valueInJSON.data.setting.button_text_before;
    
      button_type = prd_details["wishlisted"]
        ? collection_page
          ? valueInJSON.data.setting.product_collection_button_type
          : valueInJSON.data.setting.button_type
        : collection_page
        ? valueInJSON.data.setting.product_collection_button_type
        : valueInJSON.data.setting.button_type;
    
      total_count = collection_page
        ? valueInJSON.data.setting.product_collection_total_count
        : valueInJSON.data.setting.total_count;
    
      className = prd_details["wishlisted"]
        ? collection_page
          ? "th_wl_button_after"
          : "th_wl_button_after"
        : "th_wl_button";

      buttonCol_color_before2 = prd_details["wishlisted"]
        ? collection_page
          ? valueInJSON.data.setting.product_collection_button_color_before
          : valueInJSON.data.setting.button_color_before
        : collection_page
        ? valueInJSON.data.setting.product_collection_button_color_before
        : valueInJSON.data.setting.button_color_before;
    } else {
      button_text_before = collection_page
        ? valueInJSON.data.setting.product_collection_button_text_before
        : valueInJSON.data.setting.button_text_before;
    
      button_type = collection_page
        ? valueInJSON.data.setting.product_collection_button_type
        : valueInJSON.data.setting.button_type;
    
      total_count = collection_page
        ? valueInJSON.data.setting.product_collection_total_count
        : valueInJSON.data.setting.total_count;
    
      className = "th_wl_button";

      buttonCol_color_before2 = collection_page
        ? valueInJSON.data.setting.product_collection_button_color_before
        : valueInJSON.data.setting.button_color_before;
    }
    let functionName;
    multiple_wishlist = valueInJSON.data.setting.multiple_wishlist;
    if(multiple_wishlist && valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
      functionName='th_wl_open_dropdown_content(this)';
    }else{
      if (className == 'th_wl_button_after') {
        functionName = 'removeToWishlist(this)';
      } else {
        functionName = 'addToWishlist(this, event)';
      }
    }
    let th_wl_need_to_show_dropdown_content=false;
    if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
      th_wl_need_to_show_dropdown_content=true;
    }else{
      if(prd_details.wishlisted){th_wl_need_to_show_dropdown_content=false}else{th_wl_need_to_show_dropdown_content=true}
    }
    let wishlistDropdown = '';
    var innerHTML = '';
    innerHTML += '<div class="d-flex">';
    innerHTML += `<div class="${className}" onclick="${functionName}" ${(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1) ?'onfocusout="th_wl_close_dropdown_content(this)"' : ''}>`;
    if (prd_details?.wishlisted) {
      innerHTML += iconAfter;
    }
    else {
     innerHTML += iconBefor; 
    }
    if (button_type === "3") {
      innerHTML += '<span class="th_wl_text">'+ button_text_before +'</span>';
    }
    if (total_count === 1 && (prd_details?.wishlistCount)) {
     innerHTML +='<span class="th_wl_count" style="margin-left: 5px">('+ prd_details?.wishlistCount +')</span>'; 
    }
    innerHTML += '</div>';
    if (prd_details) {
      if (multiple_wishlist && th_wl_need_to_show_dropdown_content) {
        innerHTML += '<div class="th_wl_dropdown" onclick="dropdownOpen(this)" onfocusout="dropdownClose(this)">';
        innerHTML += '<button type="button" class="th_wl_dropbtn">';
        innerHTML += '<svg width="20px" height="20px" viewBox="0 0 20 20"><path fill="'+ buttonCol_color_before2 +'" d="M13.098 8H6.902c-.751 0-1.172.754-.708 1.268L9.292 12.7c.36.399 1.055.399 1.416 0l3.098-3.433C14.27 8.754 13.849 8 13.098 8Z"></path></svg>';
        innerHTML += '</button>';
        innerHTML += '<ul class="th_wl_dropdown_content">';
        innerHTML += th_wl_return_externalContent(externalContent,prd_details);
        innerHTML += '<li><span class="th_wl_dropdown_option" onclick="createnewlist(this)">' + valueInJSON?.data?.setting?.wishlist_dropdown_text + '</span></li>';
        innerHTML += '</ul>';
        innerHTML += '</div>';
      }
    } else {
      if (multiple_wishlist && th_wl_need_to_show_dropdown_content) {
        innerHTML += '<div class="th_wl_dropdown" onclick="dropdownOpen(this)" onfocusout="dropdownClose(this)">';
        innerHTML += '<button type="button" class="th_wl_dropbtn">';
        innerHTML += '<svg width="20px" height="20px" viewBox="0 0 20 20"><path fill="'+ buttonCol_color_before2 +'" d="M13.098 8H6.902c-.751 0-1.172.754-.708 1.268L9.292 12.7c.36.399 1.055.399 1.416 0l3.098-3.433C14.27 8.754 13.849 8 13.098 8Z"></path></svg>';
        innerHTML += '</button>';
        innerHTML += '<ul class="th_wl_dropdown_content">';
        innerHTML += th_wl_return_externalContent(externalContent,prd_details);
        innerHTML += '<li><span class="th_wl_dropdown_option" onclick="createnewlist(this)">' + valueInJSON?.data?.setting?.wishlist_dropdown_text + '</span></li>';
        innerHTML += '</ul>';
        innerHTML += '</div>';
      }
    }
    innerHTML += '</div>';
    if (valueInJSON.data.setting.is_variant_wishlist == 1) {
      if (vId) { val.innerHTML = innerHTML;  }
    } else {
      if (pId) { val.innerHTML = innerHTML; }
    }
  }
  const addCSSToProducts = () => {
    let isModalOpen = false;
    let button_position = "left";
    let button_position_full = "inline-flex";
    let button_position_width_full = "auto";
    let button_background = "transparent";
    let button_border_color = "transparent";
    let button_border_width = "0";
    let button_background_after = "transparent";
    let button_border_color_after = "transparent";
    let button_color_before = "#000000";
    let button_color_after = "#ff0000";
    let button_border_radius = "0";
    let button_border_type = "solid";
    let button_top_bottom_padding = "0";
    let button_left_right_padding = "0";
    let buttonDef_position = "left";
    let buttonDef_position_full = "inline-flex";
    let buttonDef_position_width_full = "auto";
    let buttonDef_background = "transparent";
    let buttonDef_border_color = "transparent";
    let buttonDef_border_width = "0";
    let buttonDef_background_after = "transparent";
    let buttonDef_border_color_after = "transparent";
    let buttonDef_color_before = "#000000";
    let buttonDef_color_after = "#ff0000";
    let buttonDef_border_radius = "0";
    let buttonDef_border_type = "solid";
    let buttonDef_top_bottom_padding = "0";
    let buttonDef_left_right_padding = "0";
    let buttonCol_position = "left";
    let buttonCol_position_full = "inline-flex";
    let buttonCol_position_width_full = "auto";
    let buttonCol_background = "transparent";
    let buttonCol_border_color = "transparent";
    let buttonCol_border_width = "0";
    let buttonCol_background_after = "transparent";
    let buttonCol_border_color_after = "transparent";
    let buttonCol_color_before = "#000000";
    let buttonCol_color_after = "#ff0000";
    let buttonCol_border_radius = "0";
    let buttonCol_border_type = "solid";
    let buttonCol_top_bottom_padding = "0";
    let buttonCol_left_right_padding = "0";
    if (wlcPage === "product") {
        buttonDef_position = valueInJSON.data.setting.button_position === "1" ? "left" : valueInJSON.data.setting.button_position === "2" ? "right" : valueInJSON.data.setting.button_position === "3" ? "center" : "inherit";
        buttonDef_position_full = valueInJSON.data.setting.button_position === "4" ? "flex" : "inline-flex";
        buttonDef_position_width_full = valueInJSON.data.setting.button_position === "4" ? "100%" : "auto";
        buttonDef_background = valueInJSON.data.setting.button_type === "3" ? valueInJSON.data.setting.button_bg_color_before : "transparent";
        buttonDef_border_color = valueInJSON.data.setting.button_type === "3" ? valueInJSON.data.setting.button_border_color_before : "transparent";
        buttonDef_border_width = valueInJSON.data.setting.button_type === "3" ? valueInJSON.data.setting.button_border_width : "0";
        buttonDef_background_after = valueInJSON.data.setting.button_type === "3" ? valueInJSON.data.setting.button_bg_color_after : "transparent";
        buttonDef_border_color_after = valueInJSON.data.setting.button_type === "3" ? valueInJSON.data.setting.button_border_color_after : "transparent";
        buttonDef_color_before = valueInJSON.data.setting.button_color_before;
        buttonDef_border_radius = valueInJSON.data.setting.button_border_radius;
        buttonDef_border_type = valueInJSON.data.setting.button_border_type;
        buttonDef_top_bottom_padding = valueInJSON.data.setting.button_top_bottom_padding;
        buttonDef_left_right_padding = valueInJSON.data.setting.button_left_right_padding;
        buttonDef_color_after = valueInJSON.data.setting.button_color_after;
    } else {
        buttonDef_position = valueInJSON.data.setting.product_collection_button_position === "1" ? "left" : valueInJSON.data.setting.product_collection_button_position === "2" ? "right" : valueInJSON.data.setting.product_collection_button_position === "3" ? "center" : "inherit";
        buttonDef_position_full = valueInJSON.data.setting.product_collection_button_position === "4" ? "flex" : "inline-flex";
        buttonDef_position_width_full = valueInJSON.data.setting.product_collection_button_position === "4" ? "100%" : "auto";
        buttonDef_background = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_bg_color_before : "transparent";
        buttonDef_border_color = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_border_color_before : "transparent";
        buttonDef_border_width = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_border_width : "0";
        buttonDef_background_after = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_bg_color_after : "transparent";
        buttonDef_border_color_after = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_border_color_after : "transparent";
        buttonDef_color_before = valueInJSON.data.setting.product_collection_button_color_before;
        buttonDef_border_radius = valueInJSON.data.setting.product_collection_button_border_radius;
        buttonDef_border_type = valueInJSON.data.setting.button_border_type;
        buttonDef_top_bottom_padding = valueInJSON.data.setting.product_collection_button_top_bottom_padding;
        buttonDef_left_right_padding = valueInJSON.data.setting.product_collection_button_left_right_padding;
        buttonDef_color_after = valueInJSON.data.setting.product_collection_button_color_after;
    }
    button_position = valueInJSON.data.setting.button_position === "1" ? "left" : valueInJSON.data.setting.button_position === "2" ? "right" : valueInJSON.data.setting.button_position === "3" ? "center" : "inherit";
    button_position_full = valueInJSON.data.setting.button_position === "4" ? "flex" : "inline-flex";
    button_position_width_full = valueInJSON.data.setting.button_position === "4" ? "100%" : "auto";
    button_background = (valueInJSON.data.setting.button_type === "3") ? valueInJSON.data.setting.button_bg_color_before : "transparent";
    button_border_color = valueInJSON.data.setting.button_type === "3" ? valueInJSON.data.setting.button_border_color_before : "transparent";
    button_border_width = valueInJSON.data.setting.button_type === "3" ? valueInJSON.data.setting.button_border_width : "0";
    button_background_after = valueInJSON.data.setting.button_type === "3" ? valueInJSON.data.setting.button_bg_color_after : "transparent";
    button_border_color_after = valueInJSON.data.setting.button_type === "3" ? valueInJSON.data.setting.button_border_color_after : "transparent";
    button_color_before = valueInJSON.data.setting.button_color_before;
    button_border_radius = valueInJSON.data.setting.button_border_radius;
    button_border_type = valueInJSON.data.setting.button_border_type;
    button_top_bottom_padding = valueInJSON.data.setting.button_top_bottom_padding;
    button_left_right_padding = valueInJSON.data.setting.button_left_right_padding;
    button_color_after = valueInJSON.data.setting.button_color_after;
    buttonCol_position = valueInJSON.data.setting.product_collection_button_position === "1" ? "left" : valueInJSON.data.setting.product_collection_button_position === "2" ? "right" : valueInJSON.data.setting.product_collection_button_position === "3" ? "center" : "inherit";
    buttonCol_position_full = valueInJSON.data.setting.product_collection_button_position === "4" ? "flex" : "inline-flex";
    buttonCol_position_width_full = valueInJSON.data.setting.product_collection_button_position === "4" ? "100%" : "auto";
    buttonCol_background = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_bg_color_before : "transparent";
    buttonCol_border_color = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_border_color_before : "transparent";
    buttonCol_border_width = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_border_width : "0";
    buttonCol_background_after = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_bg_color_after : "transparent";
    buttonCol_border_color_after = (valueInJSON.data.setting.product_collection_button_type === "3") ? valueInJSON.data.setting.product_collection_button_border_color_after : "transparent";
    buttonCol_color_before = valueInJSON.data.setting.product_collection_button_color_before;
    buttonCol_border_radius = valueInJSON.data.setting.product_collection_button_border_radius;
    buttonCol_border_type = valueInJSON.data.setting.button_border_type;
    buttonCol_top_bottom_padding = valueInJSON.data.setting.product_collection_button_top_bottom_padding;
    buttonCol_left_right_padding = valueInJSON.data.setting.product_collection_button_left_right_padding;
    buttonCol_color_after = valueInJSON.data.setting.product_collection_button_color_after;
    let displaymodal = isModalOpen ? "block" : "none";
    iconBefor = valueInJSON.data.setting?.icon ? valueInJSON.data.setting.icon : '<svg class="th_wl_icon" width="16px" height="16px" viewBox="0 0 26 23" fill=' + button_color_before + '><path d="M24.8759 3.27339C24.1475 2.06525 23.0806 1.12141 21.8207 0.57048C20.3932 -0.0562504 18.7897 -0.169062 17.1839 0.245058C15.7124 0.624602 14.279 1.4478 13 2.64198C11.7209 1.44769 10.2874 0.624442 8.8156 0.244952C7.20974 -0.169327 5.60622 -0.0564097 4.17865 0.570745C2.91872 1.12185 1.8519 2.06588 1.12359 3.27418C0.360858 4.53529 -0.0271625 6.06892 0.00147825 7.70909C0.128635 15.0007 10.5135 21.6311 12.594 22.8863C12.7175 22.9608 12.8575 23 13 23C13.1425 23 13.2825 22.9608 13.406 22.8863C15.4867 21.6309 25.8725 14.9993 25.9986 7.70782C26.0269 6.06775 25.6387 4.53428 24.8759 3.27339V3.27339ZM24.3739 7.67728C24.3332 10.0348 22.8306 12.7835 20.0288 15.6259C17.4342 18.258 14.4828 20.242 13 21.1651C11.5172 20.2422 8.56627 18.2584 5.97185 15.6262C3.16993 12.784 1.66731 10.0356 1.62618 7.67808C1.58129 5.10386 2.77074 3.03273 4.80794 2.13773C5.4756 1.84606 6.19237 1.69728 6.91592 1.70019C8.78442 1.70019 10.7609 2.64623 12.4206 4.41138C12.4962 4.49179 12.5864 4.55566 12.6859 4.59926C12.7853 4.64285 12.8921 4.6653 12.9999 4.6653C13.1078 4.6653 13.2145 4.64285 13.314 4.59926C13.4134 4.55566 13.5036 4.49179 13.5792 4.41138C15.885 1.95916 18.8021 1.08796 21.1913 2.13757C23.2287 3.03225 24.4183 5.10307 24.3739 7.67712V7.67728Z" fill=' + button_color_before + '/></svg>';
    iconAfter = valueInJSON.data.setting?.icon ? valueInJSON.data.setting.icon : '<svg class="th_wl_icon" version="1.1" id="Layer_1" x="0px" y="0px" fill=' + button_color_after + ' width="16px" height="16px" viewBox="0 0 26 23" ><path d="M25.3,7.9c-0.1,6.9-9.9,13.2-11.9,14.4c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-2-1.2-11.8-7.5-11.9-14.3 c0-1.6,0.3-3,1.1-4.2c0.7-1.1,1.7-2,2.9-2.6C6,0.6,7.5,0.5,9,0.9c1.4,0.4,2.8,1.1,4,2.3c1.2-1.1,2.6-1.9,4-2.3 c1.5-0.4,3-0.3,4.4,0.3c1.2,0.5,2.2,1.4,2.9,2.6C24.9,4.9,25.3,6.4,25.3,7.9z"/></svg>';
    if (valueInJSON.data.setting?.icon == "<svg width=\"26\" height=\"23\" viewBox=\"0 0 26 23\" fill=\"none\"><path d=\"M24.8759 3.27339C24.1475 2.06525 23.0806 1.12141 21.8207 0.57048C20.3932 -0.0562504 18.7897 -0.169062 17.1839 0.245058C15.7124 0.624602 14.279 1.4478 13 2.64198C11.7209 1.44769 10.2874 0.624442 8.8156 0.244952C7.20974 -0.169327 5.60622 -0.0564097 4.17865 0.570745C2.91872 1.12185 1.8519 2.06588 1.12359 3.27418C0.360858 4.53529 -0.0271625 6.06892 0.00147825 7.70909C0.128635 15.0007 10.5135 21.6311 12.594 22.8863C12.7175 22.9608 12.8575 23 13 23C13.1425 23 13.2825 22.9608 13.406 22.8863C15.4867 21.6309 25.8725 14.9993 25.9986 7.70782C26.0269 6.06775 25.6387 4.53428 24.8759 3.27339V3.27339ZM24.3739 7.67728C24.3332 10.0348 22.8306 12.7835 20.0288 15.6259C17.4342 18.258 14.4828 20.242 13 21.1651C11.5172 20.2422 8.56627 18.2584 5.97185 15.6262C3.16993 12.784 1.66731 10.0356 1.62618 7.67808C1.58129 5.10386 2.77074 3.03273 4.80794 2.13773C5.4756 1.84606 6.19237 1.69728 6.91592 1.70019C8.78442 1.70019 10.7609 2.64623 12.4206 4.41138C12.4962 4.49179 12.5864 4.55566 12.6859 4.59926C12.7853 4.64285 12.8921 4.6653 12.9999 4.6653C13.1078 4.6653 13.2145 4.64285 13.314 4.59926C13.4134 4.55566 13.5036 4.49179 13.5792 4.41138C15.885 1.95916 18.8021 1.08796 21.1913 2.13757C23.2287 3.03225 24.4183 5.10307 24.3739 7.67712V7.67728Z\" fill=\"black\"></path></svg>") {
        iconBefor = '<svg class="th_wl_icon" width="16px" height="16px" viewBox="0 0 26 23" fill=' + button_color_before + '><path d="M24.8759 3.27339C24.1475 2.06525 23.0806 1.12141 21.8207 0.57048C20.3932 -0.0562504 18.7897 -0.169062 17.1839 0.245058C15.7124 0.624602 14.279 1.4478 13 2.64198C11.7209 1.44769 10.2874 0.624442 8.8156 0.244952C7.20974 -0.169327 5.60622 -0.0564097 4.17865 0.570745C2.91872 1.12185 1.8519 2.06588 1.12359 3.27418C0.360858 4.53529 -0.0271625 6.06892 0.00147825 7.70909C0.128635 15.0007 10.5135 21.6311 12.594 22.8863C12.7175 22.9608 12.8575 23 13 23C13.1425 23 13.2825 22.9608 13.406 22.8863C15.4867 21.6309 25.8725 14.9993 25.9986 7.70782C26.0269 6.06775 25.6387 4.53428 24.8759 3.27339V3.27339ZM24.3739 7.67728C24.3332 10.0348 22.8306 12.7835 20.0288 15.6259C17.4342 18.258 14.4828 20.242 13 21.1651C11.5172 20.2422 8.56627 18.2584 5.97185 15.6262C3.16993 12.784 1.66731 10.0356 1.62618 7.67808C1.58129 5.10386 2.77074 3.03273 4.80794 2.13773C5.4756 1.84606 6.19237 1.69728 6.91592 1.70019C8.78442 1.70019 10.7609 2.64623 12.4206 4.41138C12.4962 4.49179 12.5864 4.55566 12.6859 4.59926C12.7853 4.64285 12.8921 4.6653 12.9999 4.6653C13.1078 4.6653 13.2145 4.64285 13.314 4.59926C13.4134 4.55566 13.5036 4.49179 13.5792 4.41138C15.885 1.95916 18.8021 1.08796 21.1913 2.13757C23.2287 3.03225 24.4183 5.10307 24.3739 7.67712V7.67728Z" fill=' + button_color_before + '/></svg>';
        iconAfter = '<svg class="th_wl_icon" version="1.1" id="Layer_1" x="0px" y="0px" fill=' + button_color_after + ' width="16px" height="16px" viewBox="0 0 26 23" ><path d="M25.3,7.9c-0.1,6.9-9.9,13.2-11.9,14.4c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-2-1.2-11.8-7.5-11.9-14.3 c0-1.6,0.3-3,1.1-4.2c0.7-1.1,1.7-2,2.9-2.6C6,0.6,7.5,0.5,9,0.9c1.4,0.4,2.8,1.1,4,2.3c1.2-1.1,2.6-1.9,4-2.3 c1.5-0.4,3-0.3,4.4,0.3c1.2,0.5,2.2,1.4,2.9,2.6C24.9,4.9,25.3,6.4,25.3,7.9z"/></svg>';
    }
    deleteIcon = '<svg  viewBox="0 0 24 24"><path d="m21 5h-18a1 1 0 0 0 0 2h2v12a2.9991 2.9991 0 0 0 3 3h8a2.9989 2.9989 0 0 0 3-3v-12h2a1 1 0 0 0 0-2zm-4 14a1.0014 1.0014 0 0 1 -1 1h-8a1.0014 1.0014 0 0 1 -1-1v-12h10z"/><path d="m10 4h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2z"/><path d="m11 16v-5a1 1 0 0 0 -2 0v5a1 1 0 0 0 2 0z"/><path d="m15 16v-5a1 1 0 0 0 -2 0v5a1 1 0 0 0 2 0z"/></svg>'
    let cssdata = '.th_wl_btn{z-index:2;position: relative; display: flex; justify-content: ' + buttonDef_position + ';} ' +
        '.th_prd_wl_btn{ z-index:2; position: relative; display: flex; justify-content: ' + button_position + ';} ' +
        '.th_wl_col_btn{ z-index:2;position: relative; display: flex; justify-content: ' + buttonCol_position + ';} ' +
        '.th_wl_btn .th_wl_button{width:' + buttonDef_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonDef_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonDef_color_before + '; background:' + buttonDef_background + ';border-color:' + buttonDef_border_color + '; border-width:' + buttonDef_border_width + 'px; border-radius: ' + buttonDef_border_radius + 'px;border-style:' + buttonDef_border_type + '; padding: ' + buttonDef_top_bottom_padding + 'px ' + buttonDef_left_right_padding + 'px;}' +  
        '.th_prd_wl_btn .th_wl_button{width:' + button_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + button_position_full + '; flex-wrap: wrap; align-items: center; color: ' + button_color_before + '; background:' + button_background + ';border-color:' + button_border_color + '; border-width:' + button_border_width + 'px; border-radius: ' + button_border_radius + 'px;border-style:' + button_border_type + '; padding: ' + button_top_bottom_padding + 'px ' + button_left_right_padding + 'px;}' +
        '.th_wl_col_btn .th_wl_button{width:' + buttonCol_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonCol_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonCol_color_before + '; background:' + buttonCol_background + ';border-color:' + buttonCol_border_color + '; border-width:' + buttonCol_border_width + 'px; border-radius: ' + buttonCol_border_radius + 'px;border-style:' + buttonCol_border_type + '; padding: ' + buttonCol_top_bottom_padding + 'px ' + buttonCol_left_right_padding + 'px;}' +
        '.th_wl_btn .th_wl_button_after{width:' + buttonDef_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonDef_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonDef_color_after + '; background:' + buttonDef_background_after + ';border-color:' + buttonDef_border_color_after + '; border-width:' + buttonDef_border_width + 'px; border-radius: ' + buttonDef_border_radius + 'px;border-style:' + buttonDef_border_type + '; padding: ' + buttonDef_top_bottom_padding + 'px ' + buttonDef_left_right_padding + 'px;}' +  
        '.th_prd_wl_btn .th_wl_button_after{width:' + button_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + button_position_full + '; flex-wrap: wrap; align-items: center; color: ' + button_color_after + '; background:' + button_background_after + ';border-color:' + button_border_color_after + '; border-width:' + button_border_width + 'px; border-radius: ' + button_border_radius + 'px;border-style:' + button_border_type + '; padding: ' + button_top_bottom_padding + 'px ' + button_left_right_padding + 'px;}' +
        '.th_wl_col_btn .th_wl_button_after{width:' + buttonCol_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonCol_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonCol_color_after + '; background:' + buttonCol_background_after + ';border-color:' + buttonCol_border_color_after + '; border-width:' + buttonCol_border_width + 'px; border-radius: ' + buttonCol_border_radius + 'px;border-style:' + buttonCol_border_type + '; padding: ' + buttonCol_top_bottom_padding + 'px ' + buttonCol_left_right_padding + 'px;}' +
        '.th_wl_button .th_wl_icon, .th_wl_button_after .th_wl_icon{margin-right:6px; width: 16px; height: 16px;}' +
        '.th_wl_modal {align-items: center; justify-content: center; background: #00000047;overflow-x: hidden; overflow-y: auto; z-index: 99999;position: fixed;top: 0;right: 0;bottom: 0;left: 0;display:none}' +
        '.th_wl_fade{opacity: 1;}' +
        '.th_wl_modal-dialog{flex: 0 0 500px; max-width: 500px;margin: 1.75rem auto; position: relative;width: auto;pointer-events: none;webkit-transform: translate(0,0);transform: translate(0,0);transition: -webkit-transform .3s ease-out;transition: transform .3s ease-out;transition: transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform: translate(0,-25%);transform: translate(0,-25%);}' +
        '.th_wl_modal_content{position: relative;display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-orient: vertical;-webkit-box-direction: normal;-ms-flex-direction: column;flex-direction: column;width: 100%;pointer-events: auto;background-color: #fff;background-clip: padding-box;border: 1px solid rgba(0,0,0,.2);border-radius: 0.3rem;outline: 0;}' +
        '.th_wl_modal_header{display: flex;-webkit-box-align: start; align-items: center;-webkit-box-pack: justify;justify-content: space-between;padding: 16px;border-bottom: 1px solid #e9ecef;border-top-left-radius: 0.3rem;border-top-right-radius: 0.3rem;}' +
        '.th_wl_modal_title{margin-bottom: 0; line-height: 1.5;font-size: 20px;font-weight: 600;margin:0}' +
        '.th_wl_modal_close{cursor:pointer; padding: 16px;margin: -16px -16px -16px auto;background-color: transparent; border: 0;float: right;font-size: 20px;font-weight: 700;line-height: 1;color: #000;text-shadow: 0 1px 0 #fff;opacity: .5;}' +
        '.th_wl_modal_body{padding: 16px}' +
        '.th_wl_lbl{display: inline-block;margin-bottom: 5px;font-size: 15px; font-weight: 600;}' +
        '.th_wl_form_control{display: block;width: 100%;padding: 6px 12px;font-size: 15px;line-height: 1.5;color: #495057;background-color: #fff;background-clip: padding-box; border: 1px solid #ced4da; border-radius: 4px; transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;}' +
        '.th_wl_form_control:focus {color: #495057;background-color: #fff;border-color: #ced4da; outline: 0;box-shadow:unset;}' +
        '.th_wl_form_text{color: #6c757d;display: block;margin-top: 4px;font-size: 80%;font-weight: 400;}' +
        '.th_wl_modal_footer{display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-align: center;-ms-flex-align: center;align-items: center;-webkit-box-pack: end;-ms-flex-pack: end;justify-content: flex-end;padding: 1rem;border-top: 1px solid #e9ecef;}' +
        '.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn, .th_wl_btn_modal{display: inline-block; font-weight: 400; text-align: center; white-space: nowrap; vertical-align: middle; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; border: 1px solid transparent; padding: 0.375rem 0.75rem; font-size: 15px; line-height: 1.5; border-radius: 0.25rem; transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;}' +
        '.th_wl_btn-secondary{margin-right: 10px; color: ' + valueInJSON.data.setting.wishlist_model_cancel_button_text_colour + '; background-color: ' + valueInJSON.data.setting.wishlist_model_cancel_button_bg_colour + '; border-color: ' + valueInJSON.data.setting.wishlist_model_cancel_button_bg_colour + '; cursor: pointer;}' +
        '.th_wl_btn-primary{color: ' + valueInJSON.data.setting.wishlist_model_create_button_text_colour + '; background-color: ' + valueInJSON.data.setting.wishlist_model_create_button_bg_colour + '; border-color: ' + valueInJSON.data.setting.wishlist_model_create_button_bg_colour + '; cursor: pointer; position: relative; }' +
        '.wl_btn_loading{position: absolute; width: 100%; height: 100%; left: 0;top: 0;display: flex; align-items: center;justify-content: center; flex-wrap: wrap; z-index: 2; background-color: ' + valueInJSON.data.setting.wishlist_model_create_button_bg_colour + ';}' +
        '.th_wl_btn-primary .wl_btn_loading svg path{fill: ' + valueInJSON.data.setting.wishlist_model_create_button_text_colour + ';}' +
        '.th_wl_btn-primary .wl_btn_loading svg {width: 35px; height: 35px;}'+
        '.th_wl_btn .th_wl_dropbtn{height: 100%;justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonDef_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonDef_color_before + '; background:' + buttonDef_background + ';border-color:' + buttonDef_border_color + '; border-width:' + buttonDef_border_width + 'px; border-radius: ' + buttonDef_border_radius + 'px;border-style:' + buttonDef_border_type + '; padding: ' + buttonDef_top_bottom_padding + 'px ' + buttonDef_left_right_padding + 'px;border-left: 0;}' +
        '.th_prd_wl_btn .th_wl_dropbtn{height: 100%;justify-content: center;cursor: pointer; font-size:16px; display: ' + button_position_full + '; flex-wrap: wrap; align-items: center; color: ' + button_color_before + '; background:' + button_background + ';border-color:' + button_border_color + '; border-width:' + button_border_width + 'px; border-radius: ' + button_border_radius + 'px;border-style:' + button_border_type + '; padding: ' + button_top_bottom_padding + 'px ' + button_left_right_padding + 'px;border-left: 0;}' +
        '.th_wl_col_btn .th_wl_dropbtn{height: 100%;justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonCol_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonCol_color_before + '; background:' + buttonCol_background + ';border-color:' + buttonCol_border_color + '; border-width:' + buttonCol_border_width + 'px; border-radius: ' + buttonCol_border_radius + 'px;border-style:' + buttonCol_border_type + '; padding: ' + buttonCol_top_bottom_padding + 'px ' + buttonCol_left_right_padding + 'px;border-left: 0;}' +
        '.th_wl_dropdown{position: relative;display: inline-block;}' +
        '.th_wl_dropdown_content{right: 0; z-index: 100000 !important; border: 1px solid #c7c7c7; border-top: 0;display: none;position: absolute;background-color: #fff;min-width: 160px; overflow: auto;z-index: 1; margin: 0;padding: 0;list-style: none;}' +
        'ul.th_wl_dropdown_content li{display: flex; justify-content: space-between; cursor:pointer; color: black;padding:0;text-decoration: none;text-align: start; font-size: 14px;}' +
        'ul.th_wl_dropdown_content li span.th_wl_dropdown_option{flex:0 0 calc(100% - 24px);padding:4px 10px;}' +
        'ul.th_wl_dropdown_content li span.th_wl_dropdown_option_delete_btn{border-left:1px solid transparent;flex:0 0 24px;display: flex;align-items: center;justify-content: center;  }' +
        'ul.th_wl_dropdown_content li span.th_wl_dropdown_option_delete_btn svg{width:14px;height:14px;}' +
        'ul.th_wl_dropdown_content li:hover{background: #e9e9e9;}' +
        'ul.th_wl_dropdown_content li:hover span.th_wl_dropdown_option_delete_btn{border-color:#c7c7c7}' +
        'ul.th_wl_dropdown_content li span.th_wl_dropdown_option_delete_btn:hover{background:#c7c7c7}' +
        '.th_wl_dropdown_option_delete_btn{cursor: pointer;}' +
        '.d-flex{display: flex}' + 'span.th_wl_wishlist_list_from_dropdown {width: -webkit-fill-available;}'+
        '.th_wl_button svg, .th_wl_button_after svg{width:16px; height:16px}' +
        '.th_wl_btn .th_wl_button svg, .th_wl_btn .th_wl_button svg path{fill:' + buttonDef_color_before + '}' +
        '.th_prd_wl_btn .th_wl_button svg, .th_prd_wl_btn .th_wl_button svg path{fill:' + button_color_before + '}' +
        '.th_wl_col_btn .th_wl_button svg, .th_wl_col_btn .th_wl_button svg path{fill:' + buttonCol_color_before + '}' +
        '.th_wl_btn .th_wl_button_after svg, .th_wl_btn .th_wl_button_after svg path{fill:' + buttonDef_color_after + '}' +
        '.th_prd_wl_btn .th_wl_button_after svg, .th_prd_wl_btn .th_wl_button_after svg path{fill:' + button_color_after + '}' +
        '.th_wl_col_btn .th_wl_button_after svg, .th_wl_col_btn .th_wl_button_after svg path{fill:' + buttonCol_color_after + '}' +
        '#th-wl-sucess-mgs,#th-wl-error-mgs {font-size: 17px;min-width: 250px;padding: 10px 12px;text-align: left;border-radius: 2px;position: fixed;right: 0;top: 0;z-index: 99999;-webkit-animation-name: fadeInRight;animation-name: fadeInRight;-webkit-animation-delay: 50ms;-moz-animation-delay: 50ms;animation-delay: 50ms;-webkit-animation-duration: 300ms;animation-duration: 300ms;-webkit-animation-fill-mode: both;animation-fill-mode: both;}' +
        '#th-wl-sucess-mgs {color: ' + valueInJSON.data.setting.success_message_text_color + ';background-color: ' + valueInJSON.data.setting.success_message_bg_color + ';}' +
        '#th-wl-error-mgs {color: ' + valueInJSON.data.setting.error_message_text_color + ';background-color: ' + valueInJSON.data.setting.error_message_bg_color + ';}' +
        '@-webkit-keyframes fadeInRight {from { opacity: 0; -webkit-transform: translate3d(100%, 0, 0); transform: translate3d(100%, 0, 0);}to { opacity: 1;  -webkit-transform: none; transform: none;}}' +
        '@keyframes fadeInRight {from { opacity: 0; -webkit-transform: translate3d(100%, 0, 0); transform: translate3d(100%, 0, 0);  }to { opacity: 1;  -webkit-transform: none;  transform: none;  }}' +
        '@media (max-width: 575px) {.th_wl_modal-dialog{flex: 0 0 calc(100% - 30px); max-width: calc(100% - 30px);}}' +
        '#loading-spinner {animation: loading-spinner 1s linear infinite}' +
        '.th_wlc_position_relative {position: relative;display: flex;justify-content: center;align-items: center;}'+
        '.th_wlc_product_count {position: absolute;background-color: #000000;color: #ffffff;height: 17px;width: 17px;border-radius: 100%;display: flex;justify-content: center;align-items: center;font-size: 10px;top: 2px;right: -4px;} '+
        '@keyframes loading-spinner{from{transform: rotate(0deg);} to {transform: rotate(360deg);}}';
    if (document.getElementById('wc_stylesheet_tag_wishlist')) {
      var element = document.getElementById('wc_stylesheet_tag_wishlist');
      element.remove();
    }
    var wc_head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style');
    wc_head.appendChild(style);
    style.type = 'text/css';
    style.id = 'wc_stylesheet_tag_wishlist';
    if (style.styleSheet) {
        style.styleSheet.cssText = cssdata;
    } else {
        style.appendChild(document.createTextNode(cssdata)); 
    }
    if(document.querySelector(".th_wlc_position_relative") && valueInJSON){
        if(valueInJSON?.data?.setting?.icon){
            document.querySelectorAll('.th_wlc_position_relative').forEach(function (th_wlc_icon, idx) {
              if (th_wlc_icon.querySelector("svg")) {
               th_wlc_icon.querySelector("svg").remove(); 
              }
                let newWlIcon = "";
                newWlIcon += th_wlc_icon.innerHTML;
                newWlIcon += valueInJSON?.data?.setting?.icon ? valueInJSON?.data?.setting?.icon : '<svg width="26" height="23" viewBox="0 0 26 23" fill="none"><path d="M24.8759 3.27339C24.1475 2.06525 23.0806 1.12141 21.8207 0.57048C20.3932 -0.0562504 18.7897 -0.169062 17.1839 0.245058C15.7124 0.624602 14.279 1.4478 13 2.64198C11.7209 1.44769 10.2874 0.624442 8.8156 0.244952C7.20974 -0.169327 5.60622 -0.0564097 4.17865 0.570745C2.91872 1.12185 1.8519 2.06588 1.12359 3.27418C0.360858 4.53529 -0.0271625 6.06892 0.00147825 7.70909C0.128635 15.0007 10.5135 21.6311 12.594 22.8863C12.7175 22.9608 12.8575 23 13 23C13.1425 23 13.2825 22.9608 13.406 22.8863C15.4867 21.6309 25.8725 14.9993 25.9986 7.70782C26.0269 6.06775 25.6387 4.53428 24.8759 3.27339V3.27339ZM24.3739 7.67728C24.3332 10.0348 22.8306 12.7835 20.0288 15.6259C17.4342 18.258 14.4828 20.242 13 21.1651C11.5172 20.2422 8.56627 18.2584 5.97185 15.6262C3.16993 12.784 1.66731 10.0356 1.62618 7.67808C1.58129 5.10386 2.77074 3.03273 4.80794 2.13773C5.4756 1.84606 6.19237 1.69728 6.91592 1.70019C8.78442 1.70019 10.7609 2.64623 12.4206 4.41138C12.4962 4.49179 12.5864 4.55566 12.6859 4.59926C12.7853 4.64285 12.8921 4.6653 12.9999 4.6653C13.1078 4.6653 13.2145 4.64285 13.314 4.59926C13.4134 4.55566 13.5036 4.49179 13.5792 4.41138C15.885 1.95916 18.8021 1.08796 21.1913 2.13757C23.2287 3.03225 24.4183 5.10307 24.3739 7.67712V7.67728Z" fill="black"></path></svg>';
                th_wlc_icon.innerHTML = newWlIcon
            });
        }
    }
  }
  const createListPopup = ($thisDetails) => {
    // Create an popup and open an popup...
    var productId = $thisDetails.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-product_id');
    var variantId = $thisDetails.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-variant_id');
    let popupStructure = `<div class="th_wl_modal-dialog th_wl_modal-dialog-centered">
        <div class="th_wl_modal_content">
          <div class="th_wl_modal_header">
            <h5 class="th_wl_modal_title">${valueInJSON?.data?.setting?.wishlist_model_title}</h5>
            <button type="button" class="th_wl_modal_close th_wl_modal_close_coman">
              <span aria-hidden="true">x</span>
            </button>
          </div>
          <div class="th_wl_modal_body">
            <label class="th_wl_lbl" for="wishlistlisttext">${valueInJSON?.data?.setting?.wishlist_model_label}</label>
            <input type="text" class="th_wl_form_control" id="wishlistlisttext" placeholder="${valueInJSON?.data?.setting?.wishlist_model_placeholder}">
            <small id="emailHelp" class="th_wl_form_text">${valueInJSON?.data?.setting?.wishlist_model_description}</small>
          </div>
          <div class="th_wl_modal_footer">
            <button type="button" class="th_wl_btn_modal th_wl_btn-secondary th_wl_modal_close_coman" data-dismiss="modal">${valueInJSON?.data?.setting?.wishlist_model_cancel_button}</button>
            <button type="button" class="th_wl_btn_modal th_wl_btn-primary th_create_new_wishlist_list" disabled="disabled" data-product_id="${productId}" data-variant_id="${variantId}">${valueInJSON?.data?.setting?.wishlist_model_create_button}</button>
          </div>
        </div>
      </div>
    </div>`;
    var htmlObject = document.createElement('div');
    htmlObject.setAttribute('class', "th_wl_modal th_wl_fade");
    htmlObject.setAttribute('id', 'createNewWishlist');
    if (document.getElementById('createNewWishlist')) {
      var mainElement = document.getElementById('createNewWishlist');
      mainElement.querySelector('.th_create_new_wishlist_list').setAttribute('data-product_id', productId);
      mainElement.querySelector('.th_create_new_wishlist_list').setAttribute('data-variant_id', variantId);
      mainElement.querySelector('#wishlistlisttext').value = '';
      mainElement.querySelector('[data-product_id]').setAttribute('disabled', 'disabled');
    } else {
      htmlObject.innerHTML = popupStructure;
      document.querySelector('body').append(htmlObject);
      createPopupJSFunctions();
    }
    document.getElementById('createNewWishlist').style.display = 'flex';
  }
  const createPopupJSFunctions = async () => {
    wl_update_customer_id();
    var mainElement = document.getElementById('createNewWishlist');
    var elemnt = mainElement.querySelector('#wishlistlisttext');
    var th_productID = mainElement.querySelector('.th_create_new_wishlist_list').getAttribute('data-product_id');
    var th_variantID = mainElement.querySelector('.th_create_new_wishlist_list').getAttribute('data-variant_id');
    elemnt.addEventListener('keyup', function(value){
      var results = elemnt.value;
      if (results == '') {
        mainElement.querySelector('[data-product_id]').setAttribute('disabled', 'disabled');
      }
      else {
        mainElement.querySelector('[data-product_id]').removeAttribute('disabled', 'disabled');
      }
    });
    document.querySelectorAll('.th_wl_modal_close_coman').forEach(function(self){
      self.addEventListener('click', function(){
        if (th_variantID) {
          var elementToClick = document.querySelector('.th_wl_col_btn[data-product_id="'+ th_productID +'"][data-variant_id="'+ th_variantID +'"], .th_prd_wl_btn[data-product_id="'+ th_productID +'"][data-variant_id="'+ th_variantID +'"], .th_wl_btn[data-product_id="'+ th_productID +'"][data-variant_id="'+ th_variantID +'"]').querySelector('.th_wl_button_after');
          if (elementToClick) {
            elementToClick.dispatchEvent(new Event('click'));
          }
        } else {
          var elementToClick = document.querySelector('.th_wl_col_btn[data-product_id="'+ th_productID +'"], .th_prd_wl_btn[data-product_id="'+ th_productID +'"], .th_wl_btn[data-product_id="'+ th_productID +'"]').querySelector('.th_wl_button_after');
          if (elementToClick) {
            elementToClick.dispatchEvent(new Event('click'));
          }
        }
        mainElement.querySelector('.th_create_new_wishlist_list').setAttribute('data-product_id', '');
        mainElement.querySelector('.th_create_new_wishlist_list').setAttribute('data-variant_id', '');
        mainElement.querySelector('#wishlistlisttext').setAttribute('value', '');
        mainElement.querySelector('[data-product_id]').setAttribute('disabled', 'disabled');
        mainElement.style.display = 'none';
      })
    });
    document.querySelector('.th_create_new_wishlist_list').addEventListener('click', function() {
      wl_update_customer_id();
      var selectedName = mainElement.querySelector('#wishlistlisttext').value;
      var th_productID = mainElement.querySelector('.th_create_new_wishlist_list').getAttribute('data-product_id');
      var th_variantID = mainElement.querySelector('.th_create_new_wishlist_list').getAttribute('data-variant_id');
      let data_json = JSON.stringify({
        shop: wlcShop,
        name: selectedName,
        customer_id: wlcCustomer_id,
        ip: valueInJSON.data.ip ? valueInJSON.data.ip : getCookieFromName('wlcIp')
      });
      createAddWishlistList(th_productID, th_variantID, data_json, selectedName);
    })
  }
  const th_wishlist_success_message = (message) => {
    if (typeof $th_wishlistAdd_callback_successMessage == 'function') {
      $th_wishlistAdd_callback_successMessage(message);
    } else {
      document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="th-wl-sucess-mgs">' + message + '</div></div>');
      setTimeout(function () { document.getElementById("th-wl-sucess-mgs").remove(); }, 4000);
    }
  }
  const th_wishlist_error_message = (message) => {
    if (typeof $th_wishlistAdd_callback_errorMessage == 'function') {
      $th_wishlistAdd_callback_errorMessage(message);
    } else {
      document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="th-wl-error-mgs">' + message + '</div></div>');
      setTimeout(function () { document.getElementById("th-wl-error-mgs").remove(); }, 4000);
    }
  }
  const createAddWishlistList = async (th_productID, th_variantID, data_json, newName) => {
    const response = await fetch(wlcApiUrl +'/v3/wishlist', {
        method: 'POST',
        body: data_json,
        headers: {
           'Content-Type': 'application/json'
        }
    });
    const myJson = await response.json();
    if (myJson.status == 200) {
      const newEntry = {
        id: myJson.id,
        name: newName,
        user_id: myJson.user_id,
      };
      th_addtowishlist_using_api(th_productID, th_variantID, myJson.id)
      th_wishlist.push(newEntry);
      localStorage.setItem('th_wishlist_lists', JSON.stringify(th_wishlist));
      getListofWishlistBlocks();
      var mainElement = document.getElementById('createNewWishlist');
      if(mainElement){
      mainElement.querySelector('.th_create_new_wishlist_list').setAttribute('data-product_id', '');
      mainElement.querySelector('.th_create_new_wishlist_list').setAttribute('data-variant_id', '');
      mainElement.querySelector('#wishlistlisttext').setAttribute('value', '');
      mainElement.querySelector('[data-product_id]').setAttribute('disabled', 'disabled');
      document.getElementById('createNewWishlist').style.display = 'none';
      }
    }
  }
  window.onDeleteWishListList = async ($this_button) => {
    wl_update_customer_id();
    if ($this_button.classList.contains('tab-link-delete')) {
        $this_button.closest('.tab-link.current').classList.add('show-loader');
    }
    let wishlistid = $this_button.getAttribute('data-wishlistid');
    let data_json = JSON.stringify({
        shop: wlcShop,
        wishlistid: wishlistid,
        ip: valueInJSON.data.ip ? valueInJSON.data.ip : getCookieFromName('wlcIp'),
        customer_id: wlcCustomer_id
    });
    const response = await fetch(wlcApiUrl + '/v3/removetab', {
        method: 'POST',
        body: data_json,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const myJson = await response.json();
    if (myJson.status === 200) {
      const indexToDelete = th_wishlist.findIndex(entry => entry.id === parseInt(wishlistid));
      if (indexToDelete !== -1) {
        th_wishlist.splice(indexToDelete, 1);
      } else {
        console.log(`No entry found with id ${wishlistid}.`);
      }
      localStorage.setItem('th_wishlist_lists', JSON.stringify(th_wishlist));
      localStorage.setItem('th_wlc_pro_count', myJson.data.total);
      totalCountUpdate();
      th_set_previous_time();
      wantToGetProductWishlistedItems();
    }
  }
  const th_addtowishlist_using_api = async (prd_id, var_id, wishlist_id) => {
    wl_update_customer_id();
    let data_json = JSON.stringify({ shop: wlcShop, product_id: prd_id, customer_id: wlcCustomer_id, wishlist_id: wishlist_id, variant_id: var_id, ip: valueInJSON.data.ip ? valueInJSON.data.ip : getCookieFromName('wlcIp') });
      const response = await fetch(wlcApiUrl + '/v3/add', {
          method: 'POST',
          body: data_json,
          headers: {
              'Content-Type': 'application/json'
          }
      });
      const myJson = await response.json();
      if (myJson.status == 200) {
        th_addwishlist_product_withdetails(prd_id, var_id,wishlist_id);
        th_wishlist_success_message(valueInJSON.data.setting.product_add_to_wishlist);
        if (myJson.data.total) {
          localStorage.setItem('th_wlc_pro_count', myJson.data.total);
          totalCountUpdate();
        }
      } else if (myJson.status == 302) {
          window.location.href = '/account';
      } else {
        th_wishlist_error_message("Product is not remove to wishlist");
        console.log('There is error while adding Product');
      }
  }
  const th_addwishlist_product_withdetails = (prd_id, var_id, wishlist_id) => {
    var copiedDate = Number(new Date());
    if (valueInJSON.data.setting.is_variant_wishlist == 1) {
      var isProVarMatch = false;
      var isProMatch = false;
      var isWishlistedTrueWhenVariantDoesNotMatch = false;
      for (let itemCount = 0; itemCount < record.length; itemCount++) {
        if (record[itemCount]['shopify_product_id'] == prd_id ) {
          record[itemCount]['shopify_product_id'].timestamp = copiedDate;
          isProMatch = true;
          let recordwishlistCount = parseInt(record[itemCount]['wishlistCount']);
          recordwishlistCount++;
          record[itemCount].wishlistCount = recordwishlistCount;
          if (record[itemCount]['shopify_variant_id'] == var_id) {
            isProVarMatch = true;
            isWishlistedTrueWhenVariantDoesNotMatch=false;
            break;
          } else {
            if (record[itemCount].wishlisted == true) {
              isWishlistedTrueWhenVariantDoesNotMatch = true;
            }
          }
        }
      }
      if (isWishlistedTrueWhenVariantDoesNotMatch) {
        for (let itemCount = 0; itemCount < record.length; itemCount++) {
          if (record[itemCount]['shopify_product_id'] == prd_id ) {
            if (record[itemCount]['shopify_variant_id'] != var_id) {
              if (record[itemCount].wishlisted != false) {
                let singleRecord = Object.assign({}, record[itemCount]);
                singleRecord.shopify_variant_id = var_id;
                if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
                    singleRecord.folder=[];
                    singleRecord.folder.push(wishlist_id);
                    if(singleRecord.folder.length>0){
                    singleRecord.folder = [...new Set(singleRecord.folder)];
                   }
                }
                record.push(singleRecord);
                break;
              }
            }
          }
        }
      } else if (isProVarMatch)  {
        for (let itemCount = 0; itemCount < record.length; itemCount++) {
          if (record[itemCount]['shopify_product_id'] == prd_id ) {
            if (record[itemCount]['shopify_variant_id'] == var_id) {
              record[itemCount].wishlisted = !(record[itemCount]['wishlisted']);
              record[itemCount].wishlisted = true;
              if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
                record[itemCount].folder.push(wishlist_id);
                if(record[itemCount].folder.length>0){
                  record[itemCount].folder = [...new Set(record[itemCount].folder)];
                }
              }
              break;
            }
          }
        }
      } else if (isProMatch && !(isWishlistedTrueWhenVariantDoesNotMatch)) {
        for (let itemCount = 0; itemCount < record.length; itemCount++) {
           if (record[itemCount]['shopify_product_id'] == prd_id ) {
            if (record[itemCount]['shopify_variant_id'] != var_id) {
              if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
                  let singleRecord = Object.assign({}, record[itemCount]);
                  singleRecord.shopify_variant_id = var_id;
                  singleRecord.wishlisted = true;
                  singleRecord.folder=[];
                  singleRecord.folder.push(wishlist_id);
                  if(singleRecord.folder.length>0){
                   singleRecord.folder = [...new Set(singleRecord.folder)];
                  }
                  record.push(singleRecord);
                  break;
              }else{
                if (record[itemCount].wishlisted == false) {
                  record[itemCount].shopify_variant_id = var_id;
                  record[itemCount].wishlisted = true;
                  break;
               }
              }
            }
          }
        }
      }
    } else {
      for (let itemCount = 0; itemCount < record.length; itemCount++) {
        if (record[itemCount]['shopify_product_id'] == prd_id ) {
          let recordwishlistCount = parseInt(record[itemCount]['wishlistCount']);
          recordwishlistCount++;
          record[itemCount].wishlistCount = recordwishlistCount;
          record[itemCount].wishlisted = true;
          record[itemCount]['shopify_product_id'].timestamp = copiedDate;
          if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
            record[itemCount].folder.push(wishlist_id);
            if(record[itemCount].folder.length>0){
              record[itemCount].folder = [...new Set(record[itemCount].folder)];
            }
          }
        }
      }
    }
    localStorage.setItem("th_wishlist_products_list", JSON.stringify(record));
    getparticularWishlistBlocks(prd_id);
  }
  window.addItemWithWishlisted = (self, event) => {
    wl_update_customer_id();
    var wc_return = 0;
    if (typeof $wc_wishlist_button_clickedtoaddItem == 'function') {
      wc_return = window.$wc_wishlist_additemwishlisted(self, event);
    }
    if (wc_return) {
      return;
    }
    var prd_id = parseInt(self.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-product_id'));
    var var_id = parseInt(self.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-variant_id'));
    var wishlist_id = parseFloat(self.getAttribute('data-wishlistid'));
    th_addtowishlist_using_api(prd_id, var_id, wishlist_id);
  }
  window.addToWishlist = (self, event) => {
    var wc_return = 0;
    wl_update_customer_id();
    if (typeof $wc_wishlist_addToWishlist == 'function') {
      wc_return = window.$wc_wishlist_addToWishlist(self, event);
    }
    if (wc_return) {
      return;
    }
    var prd_id = parseInt(self.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-product_id'));
    var var_id = parseInt(self.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-variant_id'));
    var multipleList = valueInJSON.data.setting.multiple_wishlist;
    if (multipleList) {
      if (th_wishlist && th_wishlist.length > 0) {
        var th_wishlist_id = parseFloat(self.nextSibling.querySelector('ul li:first-child').querySelector('.th_wl_dropdown_option').getAttribute('data-wishlistid'));
        th_addtowishlist_using_api(prd_id, var_id, th_wishlist_id);
      } else {
        var th_link = self.nextSibling.querySelector('ul li:last-child').querySelector('.th_wl_dropdown_option');
        th_link.dispatchEvent(new Event('click'));
      }
    } else {
      const wishlistID = th_wishlist[0]?.id ?? -1;
      if (wishlistID > 0) {
        th_addtowishlist_using_api(prd_id, var_id, wishlistID);
      } else {
        let data_json = JSON.stringify({
          shop: wlcShop,
          name: valueInJSON.data.setting.default_wishlist_title,
          customer_id: wlcCustomer_id,
          ip: valueInJSON.data.ip ? valueInJSON.data.ip : getCookieFromName('wlcIp')
        });
        createAddWishlistList(prd_id, var_id, data_json, valueInJSON.data.setting.default_wishlist_title);
      }
    }
  }
  window.getTheWishlistItems = async () => {
    wl_update_customer_id();
    const urlParams = new URLSearchParams(window.location.search);
    const wlid = urlParams.get("wlid") || "";
    const payload = JSON.stringify({
      shop: wlcShop,
      customer_id: wlcCustomer_id,
      ip: valueInJSON.data.ip ? valueInJSON.data.ip : getCookieFromName('wlcIp'),
      wishlist_share: wlid,
    });
    const $wc_GetWishlist_response = await fetch(wlcApiUrl+"/v3/get-setting", {
      method: "POST",
      body: payload,
      headers: {
        "Content-Type": "application/json",
      },
    });
    const myJson = await $wc_GetWishlist_response.json();
    if (myJson) {
      console.log('myJson', myJson);
    }
  }
  window.th_set_previous_time = () => {
    var timestamp = Number(new Date().addMinutes(-5));
    for (index in record) {
      record[index].timestamp = timestamp;
    }
    localStorage.setItem("th_wishlist_products_list", JSON.stringify(record));
  }
  const th_removefromwishlist_api = async (product_id_add, variant_id_add,th_wishlist_id) => {
    wl_update_customer_id();
    let data_json = {
        shop: wlcShop,
        product_id: product_id_add,
        variant_id: variant_id_add,
        customer_id: wlcCustomer_id,
        ip: valueInJSON.data.ip ? valueInJSON.data.ip : getCookieFromName('wlcIp')
    };
    if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
       data_json.folder_id=th_wishlist_id;
     }
    data_json=JSON.stringify(data_json);
    const response = await fetch(wlcApiUrl + '/v3/remove', {
        method: 'POST',
        body: data_json,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const myJson = await response.json();
    if (myJson.status === 200) {
      localStorage.setItem('th_wlc_pro_count', myJson?.data?.total);
      totalCountUpdate();
      th_removewishlist_structural_changes(product_id_add, variant_id_add,th_wishlist_id);
      th_wishlist_success_message(valueInJSON.data.setting.product_remove_wishlist);
    } else {
      th_error_success_message("Product not removed from wishlist");
      console.log('Product was not being able to remove from the Store');
    }
  }
  window.th_remove_from_lsl_changes = (prd_id, var_id) => {
    th_removewishlist_structural_changes(prd_id, var_id);
  }
  const th_removewishlist_structural_changes = (prd_id, var_id,th_wishlist_id) => {
    var copiedDate = Number(new Date())
    if (valueInJSON.data.setting.is_variant_wishlist == 1) {
      var productCount = 0;
      for (let itemCount = 0; itemCount < record.length; itemCount++) {
        if (record[itemCount]['shopify_product_id'] == prd_id) {
          productCount++;
          let recordwishlistCount = parseInt(record[itemCount]['wishlistCount']);
          if (recordwishlistCount > 0) {
            recordwishlistCount--;
          }
          record[itemCount].wishlistCount.timestamp = copiedDate;
          record[itemCount].wishlistCount = recordwishlistCount;
        }
      }
      if (productCount > 1) {
        for (let itemCount = 0; itemCount < record.length; itemCount++) {
          if (record[itemCount]['shopify_product_id'] == prd_id) {
            if (record[itemCount]['shopify_variant_id'] == var_id) {
              if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1){
               if(record[itemCount].folder && record[itemCount].folder.length>=1){
                     let wl_filter_folder=record[itemCount].folder.filter((wl_folder_id)=>wl_folder_id!=th_wishlist_id);
                     record[itemCount].folder=wl_filter_folder;
                     if(wl_filter_folder.length>=1){
                       record[itemCount].wishlisted=true;
                     }else{
                       record[itemCount].wishlisted=false;
                     }
                 }
               }else{
                record.splice(itemCount, 1); 
              }
            }
          }
        }
      } else {
        for (let itemCount = 0; itemCount < record.length; itemCount++) {
          if (record[itemCount]['shopify_product_id'] == prd_id) {
            if (record[itemCount]['shopify_variant_id'] == var_id) {
              record[itemCount].wishlisted = !(record[itemCount]['wishlisted']);
              if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1 && record[itemCount].folder && record[itemCount].folder.length>=1){
                 let wl_filter_folder=record[itemCount].folder.filter((wl_folder_id)=>wl_folder_id!=th_wishlist_id);
                 record[itemCount].folder=wl_filter_folder;
                 if(wl_filter_folder.length>=1){
                   record[itemCount].wishlisted=true;
                 }
              }
            }
          }
        }
      }
    } else {
      for (let itemCount = 0; itemCount < record.length; itemCount++) {
        if (record[itemCount]['shopify_product_id'] == prd_id ) {
          let recordwishlistCount = parseInt(record[itemCount]['wishlistCount']);
          if (recordwishlistCount > 0) {
            recordwishlistCount--;
          }
          record[itemCount].wishlistCount.timestamp = copiedDate;
          record[itemCount].wishlistCount = recordwishlistCount;
          record[itemCount].wishlisted = false;
           if(valueInJSON.data.setting.is_same_wishlist!=undefined && valueInJSON.data.setting.is_same_wishlist==1 && record[itemCount].folder && record[itemCount].folder.length>=1){
             let wl_filter_folder=record[itemCount].folder.filter((wl_folder_id)=>wl_folder_id!=th_wishlist_id);
             record[itemCount].folder=wl_filter_folder;
             if(wl_filter_folder.length>=1){
               record[itemCount].wishlisted=true;
             }
           }
        }
      }
    }
    localStorage.setItem("th_wishlist_products_list", JSON.stringify(record));
    getListofWishlistBlocks();
  }
    window.removeToWishlist = (self) => {
        var wc_return = 0;
        if (typeof $wc_wishlist_removeToWishlist == 'function') {
            wc_return = window.$wc_wishlist_removeToWishlist(self);
        }
        if (wc_return) {
            return;
        }
        var prd_id = parseInt(self.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-product_id'));
        var var_id = parseInt(self.closest('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn').getAttribute('data-variant_id'));
        th_removefromwishlist_api(prd_id, var_id);
    }
  window.dropdownOpen = ($thisDetails) => {
    $thisDetails.querySelector('.th_wl_dropdown_content').style.display = 'block';
  }
  window.dropdownClose = ($thisDetails) => {
    setTimeout(function(){
      $thisDetails.querySelector('.th_wl_dropdown_content').style.display = 'none';
    }, 250);
  }
  window.createnewlist = ($thisDetails) => {
    createListPopup($thisDetails);
  }
   window.th_wl_open_dropdown_content=($this)=>{
    var th_wl_dropdown_option = $this.closest('.d-flex').querySelector('.th_wl_dropdown');
    if(th_wl_dropdown_option){
      if(th_wl_dropdown_option.querySelector('.th_wl_dropdown_content')){
           th_wl_dropdown_option.querySelector('.th_wl_dropdown_content').style.display='block';
      }
      th_wl_dropdown_option.dispatchEvent(new Event('click'));
    }
  }
  window.th_wl_close_dropdown_content=($this)=>{
    var th_wl_dropdown_option = $this.closest('.d-flex').querySelector('.th_wl_dropdown .th_wl_dropdown_content');
    if(th_wl_dropdown_option){
      setTimeout(function(){
        th_wl_dropdown_option.style.display='none';
      }, 200);
    }
  }
  window.wcruntheFunction = true;
  const onChangeVariantOptions = () => {
     document.querySelectorAll('form[action="/cart/add"]').forEach((self) => {
        self.addEventListener('change', function() {
          if (wcruntheFunction) {
            setTimeout(function() {
              if (document.querySelector('.wc_pagetype').getAttribute('data-page') == 'product') {
                var getShopifyVariantID = ShopifyAnalytics.meta.selectedVariantId;
                var getShopifyProductID = ShopifyAnalytics.meta.product.id.toString();
                if (getShopifyVariantID) {
                  let wlcProductVariant = {
                    [getShopifyVariantID]: getShopifyProductID
                  };
                  if (document.querySelectorAll('.th_prd_wl_btn[data-product_id], .th_wl_col_btn[data-product_id], .th_wl_btn[data-product_id]')) {
                   document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + getShopifyProductID + '"], .th_wl_col_btn[data-product_id="' + getShopifyProductID + '"], .th_wl_btn[data-product_id="' + getShopifyProductID + '"]').forEach(function(th_loop_this) {
                        var currentID = th_loop_this.getAttribute('data-variant_id');
                        if (getShopifyVariantID != currentID) {
                          th_loop_this.setAttribute('data-variant_id', getShopifyVariantID);
                          getparticularWishlistBlocks(getShopifyProductID);
                        }
                    }); 
                  }
                  if (document.querySelectorAll('.wc_wl_bis_btn[data-product_id]')) {
                    document.querySelectorAll('.wc_wl_bis_btn[data-product_id="' + getShopifyProductID + '"]').forEach(function(th_loop_this) {
                        var currentID = th_loop_this.getAttribute('data-variant_id');
                        if (getShopifyVariantID != currentID) {
                            th_loop_this.setAttribute('data-variant_id', getShopifyVariantID);
                            addBackInStockButton(backInStockSettings, wlBackInStockProduct)
                        }
                    });
                  }
                }
              }
            }, 200);
          }
        });
    });
  }
  const wlcGetCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
  }
  const getBackInStockSettings = async (product) => {
    let wlcIp = wlcGetCookie("wlcIp") || "";
    let data_json = JSON.stringify({ shop: wlcShop, product_ids: product });
    const response = await fetch(wlcApiUrl + '/v3/products', {
        method: 'POST',
        body: data_json,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const myJson = await response.json();
    if (myJson.status === 200) {
        backInStockSettings = myJson?.data?.bis;
        wlBackInStockProduct = myJson?.data?.products;
        addBackInStockButton(myJson?.data?.bis, myJson?.data?.products);
    }
  }
  function addBackInStockButton(backInStockSettings, wlBackInStockProduct) {
      let wcBtnText = "";
      let wcBtnTextColor = "";
      let wcBtnIsIcon = "";
      let wcBtnIsActive = "";
      let wcBtnIconColor = "";
      let wcBtnBorderSize = "";
      let wcBtnBorderRadius = "";
      let wcBtnBorderColor = "";
      let wcBtnBgColor = "";
      let wcBtnPTB = "";
      let wcBtnPLR = "";
      let wlcNewPage = document.querySelector('.wc_pagetype').getAttribute('data-page');
      if(wlcNewPage === 'product'){
          wcBtnText = backInStockSettings.product_page_widget.text;
          wcBtnTextColor = backInStockSettings.product_page_widget.text_color;
          wcBtnIsIcon = backInStockSettings.product_page_widget.is_icon;
          wcBtnIsActive = backInStockSettings.product_page_widget.is_active;
          wcBtnIconColor = backInStockSettings.product_page_widget.icon_color;
          wcBtnBorderSize = backInStockSettings.product_page_widget.border_size;
          wcBtnBorderRadius = backInStockSettings.product_page_widget.border_radius;
          wcBtnBorderColor = backInStockSettings.product_page_widget.border_color;
          wcBtnBgColor = backInStockSettings.product_page_widget.bg_color;
          wcBtnPTB = backInStockSettings.product_page_widget.button_top_bottom_padding;
          wcBtnPLR = backInStockSettings.product_page_widget.button_left_right_padding;
      } else if(wlcNewPage === 'collection'){
          wcBtnText = backInStockSettings.collection_page_widget.text;
          wcBtnTextColor = backInStockSettings.collection_page_widget.text_color;
          wcBtnIsIcon = backInStockSettings.collection_page_widget.is_icon;
          wcBtnIsActive = backInStockSettings.collection_page_widget.is_active;
          wcBtnIconColor = backInStockSettings.collection_page_widget.icon_color;
          wcBtnBorderSize = backInStockSettings.collection_page_widget.border_size;
          wcBtnBorderRadius = backInStockSettings.collection_page_widget.border_radius;
          wcBtnBorderColor = backInStockSettings.collection_page_widget.border_color;
          wcBtnBgColor = backInStockSettings.collection_page_widget.bg_color;
          wcBtnPTB = backInStockSettings.collection_page_widget.button_top_bottom_padding;
          wcBtnPLR = backInStockSettings.collection_page_widget.button_left_right_padding;
      } else if(wlcNewPage === 'home'){
          wcBtnText = backInStockSettings.home_page_widget.text;
          wcBtnTextColor = backInStockSettings.home_page_widget.text_color;
          wcBtnIsIcon = backInStockSettings.home_page_widget.is_icon;
          wcBtnIsActive = backInStockSettings.home_page_widget.is_active;
          wcBtnIconColor = backInStockSettings.home_page_widget.icon_color;
          wcBtnBorderSize = backInStockSettings.home_page_widget.border_size;
          wcBtnBorderRadius = backInStockSettings.home_page_widget.border_radius;
          wcBtnBorderColor = backInStockSettings.home_page_widget.border_color;
          wcBtnBgColor = backInStockSettings.home_page_widget.bg_color;
          wcBtnPTB = backInStockSettings.home_page_widget.button_top_bottom_padding;
          wcBtnPLR = backInStockSettings.home_page_widget.button_left_right_padding;
      }else if(wlcNewPage === 'cart'){
          wcBtnText = backInStockSettings.collection_page_widget.text;
          wcBtnTextColor = backInStockSettings.collection_page_widget.text_color;
          wcBtnIsIcon = backInStockSettings.collection_page_widget.is_icon;
          wcBtnIsActive = backInStockSettings.collection_page_widget.is_active;
          wcBtnIconColor = backInStockSettings.collection_page_widget.icon_color;
          wcBtnBorderSize = backInStockSettings.collection_page_widget.border_size;
          wcBtnBorderRadius = backInStockSettings.collection_page_widget.border_radius;
          wcBtnBorderColor = backInStockSettings.collection_page_widget.border_color;
          wcBtnBgColor = backInStockSettings.collection_page_widget.bg_color;
          wcBtnPTB = backInStockSettings.collection_page_widget.button_top_bottom_padding;
          wcBtnPLR = backInStockSettings.collection_page_widget.button_left_right_padding;
      }
      if(wcBtnIsActive == 1){
          if (document.querySelectorAll('#wcBackInStockCss').length === 0) {
              let cssData = '<style id="wcBackInStockCss">'
              cssData += `.wc_wl_bis_btn{position: relative; z-index: 99999;}`;
              cssData += `.wc_wl_bis_btn button{padding: ${wcBtnPTB}px ${wcBtnPLR}px; width: 100%; font-size: 14px; background-color: ${wcBtnBgColor}; border: ${wcBtnBorderSize}px solid ${wcBtnBorderColor}; color: ${wcBtnTextColor}; border-radius: ${wcBtnBorderRadius}px; cursor: pointer; display: flex; align-items: center; justify-content: center; }`;
              cssData += `.wc_wl_bis_btn button .wcBsiNotifyIcon{margin-right: 5px;}`;
              cssData += `.wcBsiModal{display: flex; flex-wrap: wrap; align-items: center; justify-content: center; overflow-x: hidden; overflow-y: auto; opacity: 1; z-index: 99999; position: fixed; top: 0;right: 0;bottom: 0; left: 0; outline: 0; transition: opacity .15s linear; background-color: #000000b3;}`;
              cssData += `.wcBsiModalDialog{animation: fadeIn 200ms ease-in both; transition: -webkit-transform .3s ease-out;transition: transform .3s ease-out; transition: transform .3s ease-out,-webkit-transform .3s ease-out; max-width: 360px; display: -webkit-box; display: flex; align-items: center; position: relative; pointer-events: none; flex: 0 0 360px;}`;
              cssData += `.wcBsiModalContent{position: relative; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; width: 100%; pointer-events: auto; background-color: #fff; background-clip: padding-box; border: 1px solid rgba(0,0,0,.2); border-radius: 10px; outline: 0;}`;
              cssData += `.wcBsiModalHeader{display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: start; -ms-flex-align: start; align-items: flex-start; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; padding: 1rem; border-bottom: 1px solid #e9ecef; border-top-left-radius: .3rem; border-top-right-radius: .3rem; align-items: center;}`;
              cssData += `.wcBsiHeaderTitle{margin: 0; line-height: 1.5; font-size: 20px}`;
              cssData += `.wcBsiHeaderClose{padding: 16px; margin: -1rem -1rem -1rem auto; background-color: transparent; border: 0; float: right; font-size: 18px; font-weight: 700; line-height: 1; color: #000; text-shadow: 0 1px 0 #fff; text-transform: none;cursor: pointer;}`;
              cssData += `.wcBsiHeaderClose svg{width: 16px; height: 16px; }`;
              cssData += `.wcBsiModalBody{position: relative; -webkit-box-flex: 1; -ms-flex: 1 1 auto; flex: 1 1 auto; padding: 16px 16px 20px;}`;
              cssData += `.wcBsiFormGroup{margin-bottom: 15px;}`;
              cssData += `.wcBsiFormGroup:last-child{margin-bottom: 0;}`;
              cssData += `.wcBsiFormLabel{padding-top: 5px;padding-bottom: 5px ;margin-bottom: 0;font-size: inherit; line-height: 1.5; display: inline-block}`;
              cssData += `.wcBsiFormControl{display: block;width: 100%;padding: 6px 12px;font-size: 16px;line-height: 1.5;color: #495057;background-color: #fff;background-clip: padding-box;border: 1px solid #ced4da;border-radius: 6px ;transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;}`;
              cssData += `.wcBsiFormControl:focus-visible{outline: none;outline-offset: inherit; box-shadow: none;} `;
              cssData += `select.wcBsiFormControl{padding: 6px 36px 6px 12px;font-size: 16px;line-height: 1.5;background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");-webkit-appearance: none;-moz-appearance: none;appearance: none;background-repeat: no-repeat;background-position: right 0.75rem center;background-size: 16px 12px;}`;
              cssData += `.wcBsiFormGroup small{color: #f00; visibility: hidden;opacity: 0;}`;
              cssData += `.wcBsiFormGroup.error small {visibility: visible;opacity: 1;}`
              cssData += `.wcBsiFormBtnSubmit{padding: ${backInStockSettings.subscription_form.button_top_bottom_padding}px ${backInStockSettings.subscription_form.button_left_right_padding}px; width: 100%; font-size: 14px; background-color: ${backInStockSettings.subscription_form.background_color}; border: ${backInStockSettings.subscription_form.border_size}px solid ${backInStockSettings.subscription_form.border_color}; color: ${backInStockSettings.subscription_form.text_color}; border-radius: ${backInStockSettings.subscription_form.border_radius}px; cursor: pointer }`;
              cssData += `@keyframes fadeIn {from {opacity: 0; transform: translate3d(0, -20%, 0); } to {opacity: 1; transform: translate3d(0, 0, 0);}}`
              cssData += `#wcBsiMessage{font-size: 17px;min-width: 250px;padding: 10px 12px;text-align: left;border-radius: 2px;position: fixed;right: 0;top: 0;z-index: 99999;-webkit-animation-name: fadeInRightBsiMessage;animation-name: fadeInRightBsiMessage;-webkit-animation-delay: 50ms;-moz-animation-delay: 50ms;animation-delay: 50ms;-webkit-animation-duration: 300ms;animation-duration: 300ms;-webkit-animation-fill-mode: both;animation-fill-mode: both;}`;
              cssData += `#wcBsiMessage {color: ${backInStockSettings.subscription_message.text_color};background-color: ${backInStockSettings.subscription_message.background_color};}`;
              cssData += `@-webkit-keyframes fadeInRightBsiMessage {from { opacity: 0; -webkit-transform: translate3d(100%, 0, 0); transform: translate3d(100%, 0, 0);}to { opacity: 1;  -webkit-transform: none; transform: none;}}`;
              cssData += `@keyframes fadeInRightBsiMessage {from { opacity: 0; -webkit-transform: translate3d(100%, 0, 0); transform: translate3d(100%, 0, 0);  }to { opacity: 1;  -webkit-transform: none;  transform: none;  }}`;
              cssData += '</style>';
              document.getElementsByTagName('head')[0].insertAdjacentHTML('beforeend', cssData);
          }
          if(wlBackInStockProduct){
              document.querySelectorAll(".wc_wl_bis_btn").forEach((x, i) => {
                  const productId = x.getAttribute("data-product_id");
                  const variantId = x.getAttribute("data-variant_id");
                  const findVariant = (wlBackInStockProduct || []).find((v) => v.variant_id == variantId);
                  const notifyIcon = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" ><path d="M10.0003 0C10.5525 0 11.0003 0.447716 11.0003 1V3L10.9998 3.0317L10.9988 3.05341L10.9969 3.0824C13.8362 3.55709 16.0003 6.02583 16.0003 9C16.0003 12.0933 16.6253 13.312 17.5989 15.2103L17.6336 15.2781C17.8033 15.6088 17.563 16 17.1912 16H2.80935C2.43753 16 2.19729 15.6088 2.36697 15.2781L2.40164 15.2103C3.37527 13.312 4.00027 12.0933 4.00027 9C4.00027 6.02583 6.16434 3.55709 9.00369 3.0824L9.00149 3.04284C9.00076 3.02863 9.00027 3.01435 9.00027 3V1C9.00027 0.447716 9.44803 0 10.0003 0Z" fill="'+wcBtnIconColor+'"></path><path d="M12.0003 18C12.0003 19.1046 11.1048 20 10.0003 20C8.89578 20 8.00027 19.1046 8.00027 18H12.0003Z" fill="'+wcBtnIconColor+'"></path></svg>'
                  if(findVariant?.inventoryQuantity <= 0 && findVariant?.inventoryManagement1 && findVariant?.inventoryPolicy == 'DENY'){
                      let wcBackInStockButton = "";
                      if(wcBtnIsIcon == "1"){
                          wcBackInStockButton += '<button type="button" data-product_id="'+ productId +'" data-variant_id="'+variantId+'">';
                          wcBackInStockButton += '<span class="wcBsiNotifyIcon">'+notifyIcon+'</span>';
                          wcBackInStockButton += '<span class="wcBsiNotifyText">'+wcBtnText+'</span>';
                          wcBackInStockButton += '</button>';
                      } else {
                          wcBackInStockButton += '<button type="button" data-product_id="'+ productId +'" data-variant_id="'+variantId+'"><span class="wcBsiNotifyText">'+wcBtnText+'</span></button>'
                      }

                      x.innerHTML = wcBackInStockButton;
                      x.addEventListener('click', function (event) {
                          onClickBackInStockButton(productId, variantId)
                      })
                  } else  {
                      x.innerHTML = "";
                  }
              })
          }
      };
      const showError = (input, msg) => {
          const formControl = input.parentElement;
          const small = formControl.querySelector("small");
          formControl.classList.add("error");
          small.textContent = msg;
      };
      const showSuccess = (input) => {
          const formControl = input.parentElement;
          formControl.classList.remove("error");
          formControl.querySelector("small").innerHTML = "";
      };
      const wcBsiCheckRequired = (inputArr) => {
          inputArr.forEach((input) => {
              input.addEventListener("blur", function (e) {
                  if (input.name === "wcBsiEmail") {
                      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                      if (re.test(input.value)) {
                          showSuccess(input);
                      } else {
                          showError(input, backInStockSettings.subscription_form.email_validation_message);
                      }
                  }
              });
          })
      }
      const sucessMessage = (message) => {
          document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="wcBsiMessage">' + message + '</div></div>');
          setTimeout(function () { document.getElementById("wcBsiMessage").remove(); }, 4000);
      }
      const errorMessage = (message) => {
          document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="wcBsiMessage">' + message + '</div></div>');
          setTimeout(function () { document.getElementById("wcBsiMessage").remove(); }, 4000);
      }
      const onSubmitBackInStock = async (productId, variantId) => {
          let wcBsiFormInput = [];
          document.querySelectorAll(".wcBsiFormGroup").forEach((thisInput) => {
              let name = thisInput;
              wcBsiFormInput.push(name)
          });
          wcBsiCheckRequired(wcBsiFormInput)
          if (document.querySelectorAll(".wcBsiFormGroup.error").length) {
              return true;
          } else {
              const wlcShopAnother = Shopify.shop;
              const variant_id = document.querySelector('#wcBsiVariant').value;
              const email = document.querySelector('#wcBsiEmail').value;
              const paylaod = {
                  shop: wlcShopAnother,
                  product_id: productId,
                  variant_id: variant_id || variantId,
                  email: email
              }
              await fetch(`${wlcApiUrl}/v1/bis`, {
                  method: 'POST',
                  body: JSON.stringify(paylaod),
                  cache: 'no-cache',
                  headers: {
                      'Content-Type': 'application/json'
                  },
              }).then(response => response.json()).then(async wcBsiResponse => {
                  if(wcBsiResponse.status === 200){
                      document.body.style.overflow = 'auto';
                      document.querySelector(".wcBsiModal").remove();
                      sucessMessage(backInStockSettings.subscription_message.success_message)

                  } else if(wcBsiResponse.status === 201){
                      document.body.style.overflow = 'auto';
                      document.querySelector(".wcBsiModal").remove();
                      sucessMessage(wcBsiResponse.message);

                  } else if(wcBsiResponse.status === 400){
                      document.body.style.overflow = 'auto';
                      document.querySelector(".wcBsiModal").remove();
                      errorMessage(backInStockSettings.subscription_message.already_subscribed_message)
                  }
              }).catch((error) => {
                  console.log(error);
              })
          }
      }
      const emailErrorChecker = () => {
        document.querySelector('#wcBsiEmail').addEventListener('keyup', function(event){
          var resultedValue = document.querySelector('#wcBsiEmail').value;
          var emailField = document.querySelector('#wcBsiEmail');
          var reg = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/
          if (reg.test(emailField.value) == false) { 
            document.querySelector('.wcBsiFormBtnSubmit').setAttribute('disabled', 'disabled');
          }
          else {
            document.querySelector('.wcBsiFormBtnSubmit').removeAttribute('disabled', 'disabled');
          }
        });
      }
      const onClickBackInStockButton = (productId, variantId) => {
          if(document.querySelector(".wcBsiModal")){
              document.querySelector(".wcBsiModal").remove()
          }
          let wcBisModal = "";
          const newProductToBeBackInStock = [];
          for (var k=0; k < wlBackInStockProduct.length; k++) {
            if (parseInt(wlBackInStockProduct[k]['product_id']) == parseInt(productId)) {
              newProductToBeBackInStock.push(wlBackInStockProduct[k]); 
            }
          }
          wcBisModal += '<div class="wcBsiModal">';
          wcBisModal += '<div class="wcBsiModalDialog">';
          wcBisModal += '<div class="wcBsiModalContent">';
          wcBisModal += '<div class="wcBsiModalHeader">';
          wcBisModal += '<h5 class="wcBsiHeaderTitle">'+ backInStockSettings.subscription_form.title +'</h5>';
          wcBisModal += '<button class="wcBsiHeaderClose">'
          wcBisModal += '<svg viewBox="0 0 20 20" ><path d="M11.414 10l6.293-6.293a1 1 0 10-1.414-1.414L10 8.586 3.707 2.293a1 1 0 00-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 101.414 1.414L10 11.414l6.293 6.293A.998.998 0 0018 17a.999.999 0 00-.293-.707L11.414 10z" fill="#5C5F62"/></svg>';
          wcBisModal += '</button>';
          wcBisModal += '</div>';
          wcBisModal += '<div class="wcBsiModalBody">';
          wcBisModal += '<div class="wcBsiFormGroup">';
          wcBisModal += '<label class="wcBsiFormLabel">'+backInStockSettings.subscription_form.email_lable +'</label>';
          wcBisModal +='<input type="text" class="wcBsiFormControl" name="wcBsiEmail" id="wcBsiEmail" placeholder="'+backInStockSettings.subscription_form.email_placeholder+'">';
          wcBisModal +='<small></small>';
          wcBisModal += '</div>';
          if (newProductToBeBackInStock.length == 1 && newProductToBeBackInStock[0].title == "Default Title") {
            wcBisModal += '<input type="hidden" class="wcBsiFormControl" value="'+variantId+'" name="wcBsiVariant" id="wcBsiVariant">';
          }
          else {
            wcBisModal += '<div class="wcBsiFormGroup">';
            wcBisModal += '<select class="wcBsiFormControl" value="'+variantId+'" name="wcBsiVariant" id="wcBsiVariant">';
            newProductToBeBackInStock.filter((f) => f?.inventoryQuantity <= 0 && f?.inventoryManagement1 && f?.inventoryPolicy == 'DENY').forEach((x) => {
                const seletedV = variantId === x.variant_id ? 'selected' : '';
                wcBisModal +='<option value="'+x.variant_id+'" '+seletedV+'>'+x.title+'</option>';
            });
            wcBisModal +='</select>';
            wcBisModal += '</div>'; 
          }
          wcBisModal +='<div class="wcBsiFormGroup">';
          wcBisModal +='<button class="wcBsiFormBtnSubmit" disabled="disabled">'+backInStockSettings.subscription_form.submit_button_text+'</button>';
          wcBisModal += '</div>';
          wcBisModal += '</div>';
          wcBisModal += '</div>';
          wcBisModal += '</div>';
          wcBisModal += '</div>';
          document.body.style.overflow = 'hidden';
          document.querySelector("body").insertAdjacentHTML('beforeend', wcBisModal);
          let wcBsiFormInput = [];
          document.querySelectorAll(".wcBsiFormControl").forEach((thisInput) => {
              let name = thisInput;
              wcBsiFormInput.push(name)
          });
          wcBsiCheckRequired(wcBsiFormInput)

          document.querySelector(".wcBsiFormBtnSubmit").addEventListener('click' , () => {
              onSubmitBackInStock(productId)
          })

          document.querySelectorAll(".wcBsiHeaderClose").forEach((x) => {
              x.addEventListener('click' , () => {
                  document.body.style.overflow = 'auto';
                  document.querySelector(".wcBsiModal").remove();
              })
          });
          emailErrorChecker();
      }
  };
  window.wlProductVariantChange = (productId, variantId) => {
    if(productId && variantId){
        let wlcProductVariant = {[variantId]: productId};
        document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + productId + '"], .th_wl_col_btn[data-product_id="' + productId + '"], .th_wl_btn[data-product_id="' + productId + '"]').forEach(function (th_loop_this) {
            th_loop_this.setAttribute('data-variant_id', variantId);
        });
        getparticularWishlistBlocks(productId);
    }
  }
  /*Back in stock call when variant is changed callback function start*/
  window.wlBackInStockProductVariantChange = (productId, variantId) => {
      if(productId && variantId){
          document.querySelectorAll('.wc_wl_bis_btn[data-product_id="' + productId + '"]').forEach(function (th_loop_this) {
              th_loop_this.setAttribute('data-variant_id', variantId);
          });
          addBackInStockButton(backInStockSettings, wlBackInStockProduct)
      }
  }
  /* Back in stock call when variant is changed callback function end */
  const th_wishlist_normal_block = () => {
    if (parseInt(cookieSettingVersion) == parseInt(settingVersion)) {
      addCSSToProducts(); 
      getListofWishlistBlocks();
      totalCountUpdate();
    } else {
      setCookieFromName('settingVersion', parseInt(document.querySelector('.th_setting_version_for_wishlist') ? document.querySelector('.th_setting_version_for_wishlist')?.getAttribute('data-setting-version') : "-1"));
      localStorage.removeItem("th_default_settings_content");
      localStorage.removeItem("th_wishlist_products_list");
      localStorage.removeItem("th_wishlist_lists");
      localStorage.removeItem("th_wlc_pro_count");
      valueInJSON = getLocalDetails();
      record = getLocalRecords();
      th_wishlist = getLocalthWishlists() || [];
      getSettingsDetailsFrom();
    }
  }
  const th_wishlist_block_initialisation = () => {
    if (valueInJSON) {
      if (valueInJSON.data.setting.app_enable === 1) {
        var cookieCustomerID = getCookieFromName('wlcCustomer_id');
        if (wlcCustomer_id) {
          if (parseInt(wlcCustomer_id) !== parseInt(cookieCustomerID)) {
            localStorage.removeItem("th_wishlist_products_list");
            localStorage.removeItem("th_wishlist_lists");
            localStorage.removeItem("th_wlc_pro_count");
            record = getLocalRecords();
            th_wishlist = getLocalthWishlists() || [];
            getSettingsDetailsFrom();
          } else {
            th_wishlist_normal_block();
          }
        } else {
          if (cookieCustomerID) {
            localStorage.removeItem("th_wishlist_products_list");
            localStorage.removeItem("th_wishlist_lists");
            localStorage.removeItem("th_wlc_pro_count");
            record = getLocalRecords();
            th_wishlist = getLocalthWishlists() || [];
            getSettingsDetailsFrom();
          } else {
            th_wishlist_normal_block();
          }
        }
        if (wlcCustomer_id == null) {
          setCookieFromName('wlcCustomer_id', '');
        } else {
          setCookieFromName('wlcCustomer_id', wlcCustomer_id);
        }
        if (record) {
          wantToGetProductWishlistedItems();
        }
      }
    } else {
      getSettingsDetailsFrom();
    }
    onChangeVariantOptions();
  }
  window.$th_refreshWishlistItems = () => {
    th_wishlist_block_initialisation();
  }
  window.$th_refreshBackInStockItems = () => {
    let wlcBackInStockProduct = [];
    document.querySelectorAll('.wc_wl_bis_btn:empty').forEach(function (val, idx) {
      val.innerHTML = ' ';
      let pId = val.getAttribute('data-product_id');
      wlcBackInStockProduct.push(pId);
    });
    if(wlcBackInStockProduct.length > 0){
      getBackInStockSettings(wlcBackInStockProduct)
    }
  }
  $th_refreshWishlistItems();
  $th_refreshBackInStockItems();
  window.addEventListener("load", (event) => {
    setTimeout(function() {
      $th_refreshWishlistItems();
    }, 3000);
  });
}